<template>
    <div v-if="sapProfile==true" style="overflow-x:auto !important">
        <div style="display: grid; grid-template-columns: auto 400px; grid-column-gap: 50px;">
            <div>
                <div style="display: grid; grid-template-columns: 1fr 4fr;">
                    <div class="my_color_00338e my_font-weight_600" style="padding-left:10px">{{$t('3452')}}</div>
                    <div>
                        <select v-model="selectedCustomerName" class="my_select" v-bind:disabled="showTemplateButton==true">
                            <option v-for="name in customerNameSelection" v-bind:value="name">{{name.text.useTextKey?$t(name.text.textKey):name.text.textUI}}</option>
                        </select>
                    </div>
                </div>
                <hr />
                <table style=" margin-top: 10px; width: 100%; vertical-align: middle !important" cellpadding="10">
                    <tr>
                        <td style=" width: calc(100%/5); vertical-align: top">
                            <img src="../../../../public/img/ProductImages/ZAtop/ZAtop-SM160-40B-side.jpg" style="width:100px" />
                        </td>

                        <td style=" width: calc(100%/5); vertical-align: top; padding-top:15px">
                            <h4 class="my_color_00338e my_font-weight_600">{{$t('3028')}}</h4>
                        </td>

                        <td style=" width:calc(100%/5); vertical-align:top">
                            <button v-if="(customerName==null||customerName!='SCH-MOD')&&showMotorManualSelectionButton!='2'&&sapProfile==true&&showAddOnPart==false" @click="ZAtop" class="btn my_btn_standard_blue" style="margin-top:5px;margin-right:5px" v-bind:disabled="(frameSelected!=null&&motorManualDataSelected==null)||showTemplateButton==true||plusManual==true">{{$t('3464')}}</button>
                            <button v-if="customerName!=null&&customerName=='SCH-MOD'&&showMotorManualSelectionButton!='1'&&sapProfile==true&&showAddOnPart==false" @click="ZAtop_PSG" class="btn my_btn_standard_blue" style="margin-top:5px;" v-bind:disabled="(frameSelected!=null&&motorManualDataSelected==null)||showTemplateButton==true||plusManual==true">PSG 518-600</button>
                            <button v-if="customerName!=null&&customerName=='SCH'&&showMotorManualSelectionButton!='1'&&sapProfile==true&&showAddOnPart==false" @click="ZAtop_Magic" class="btn my_btn_standard_blue" style="margin-top:5px;" v-bind:disabled="(frameSelected!=null&&motorManualDataSelected==null)||showTemplateButton==true||plusManual==true">SCH-Magic</button>
                            <button v-if="motorManualDataSelected!=null&&showTemplateButton==false&&plusManual==false&&showAddOnPart==false" style="margin-left:5px;margin-top:5px;" @click="deleteZAtop" class="btn my_btn_standard_blue" v-bind:disabled="showTemplateButton==true||plusManual==true">{{$t('3610')}}</button>
                        </td>
                        <td class="ZAfont_family ZAfont_size" style=" width:calc(100%/5*2); vertical-align:top">
                            <div v-if="motorManualDataSelected!=null && showMotorManualDetails==false">
                                <div v-if="motorManualDataSelected.details.mN_MOT!=null">
                                    <div class="my_font-weight_600">{{$t('1098')}}:</div>
                                    <div style="margin-left:5px">
                                        <span v-if="motorManualDataSelected.details.mtyP2!=null">{{motorManualDataSelected.details.mtyP2}} | </span>
                                        <span v-if="motorManualDataSelected.details.mPr1!=null">{{motorManualDataSelected.details.mPr1}} kW | </span>
                                        <span v-if="motorManualDataSelected.details.mnr!=null">{{motorManualDataSelected.details.mnr}} Upm | </span>
                                        <span v-if="motorManualDataSelected.details.mU1!=null">{{motorManualDataSelected.details.mU1}} V | </span>
                                        <span v-if="motorManualDataSelected.details.mIr1!=null">{{motorManualDataSelected.details.mIr1}} A </span>
                                    </div>
                                </div>
                                <div v-if="motorManualDataSelected.details.ltr!=null">
                                    <div class="my_font-weight_600">{{$t('411')}}:</div>
                                    <div style="margin-left:5px">
                                        <span v-if="motorManualDataSelected.details.td!=null">{{motorManualDataSelected.details.td}} mm | </span>
                                        <span v-if="motorManualDataSelected.details.tb!=null">{{motorManualDataSelected.details.tb}} mm | </span>
                                        <span v-if="motorManualDataSelected.details.tdrz!=null&&motorManualDataSelected.details.tcsd!=null">{{motorManualDataSelected.details.tdrz}}x{{motorManualDataSelected.details.tcsd}} | </span>
                                        <span v-if="motorManualDataSelected.details.tauwi!=null">{{motorManualDataSelected.details.tauwi}}&deg; |</span>
                                        <span v-if="motorManualDataSelected.details.tauwi==null&&motorManualDataSelected.details.takwi!=null">{{motorManualDataSelected.details.takwi}}&deg; | </span>
                                        <span v-if="motorManualDataSelected.details.tarill!=null">{{motorManualDataSelected.details.tarill}} | </span>
                                        <span v-if="motorManualDataSelected.details.tdra!=null">{{motorManualDataSelected.details.tdra}}</span>
                                    </div>
                                </div>
                                <div v-if="motorManualDataSelected.alternativePartnumberMotorKLK!=null&&motorManualDataSelected.mklk!=null">
                                    <div class="my_font-weight_600">
                                        <span>{{$t('3704')}}:</span>
                                        <button v-if="motorManualDataSelected.alternativePartnumberMotorKLK!=null" class="btn my_btn_standard" @click="change_partNumberMklk(motorManualDataSelected)" style="padding: 0; margin-left: 10px; border:none !important"><span class="fa fa-exchange" style="font-size: 10px;padding:5px 5px 5px 5px"></span><span style="font-size: 14px; padding-right: 5px">{{$t('3705')}}</span></button>
                                    </div>
                                    <div style="margin-left:5px">
                                        <span v-if="motorManualDataSelected.mklk!=null && motorManualDataSelected.mklk.useTextKey==false">{{motorManualDataSelected.mklk.textUI}}</span>
                                        <span v-if="motorManualDataSelected.mklk!=null && motorManualDataSelected.mklk.useTextKey==true">{{$t(motorManualDataSelected.mklk.textKey)}}</span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="motorManualDataSelected!=null">
                                <div>
                                    <button v-if="showMotorManualDetails==false" @click="ChangeMotorDetails(true)" class="btn my_btn_details">
                                        <span>&#9660; </span>
                                        <span class="my_color_00338e my_font-weight_600" style="padding: 5px;">{{$t('3240')}}</span>
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="motorManualDataSelected!=null&&showMotorManualDetails==true">
                        <td colspan="100" class="ZAfont_family ZAfont_size" style="vertical-align: top;">
                            <div>
                                <button @click="ChangeMotorDetails(false)" class="btn my_btn_details">
                                    <span>&#9650; </span>
                                    <span class="my_color_00338e my_font-weight_600" style="padding: 5px;">{{$t('3240')}}</span>
                                </button>
                            </div>
                            <div>
                                <div>
                                    <div>
                                        <div v-if="motorManualDataSelected.kid!=null" style="display: grid; grid-template-columns: 1fr 3fr;padding: 5px">
                                            <div class="my_font-weight_600">{{$t('3452')}}:</div>
                                            <div>{{motorManualDataSelected.kid}}</div>
                                            <div></div>
                                        </div>
                                        <div v-if="motorSuppliesSelected!=null&&motorSuppliesSelected.details.massbl!=null" style="display: grid; grid-template-columns: 1fr 3fr; padding: 5px">
                                            <div class="my_font-weight_600">{{$t('3544')}}:</div>
                                            <div>{{motorSuppliesSelected.details.massbl}}</div>
                                        </div>
                                        <div v-if="motorManualDataSelected.details.mN_MOT!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">{{$t('1098')}}:</div>
                                            <div>
                                                <span v-if="motorManualDataSelected.details.mtyP2!=null">{{motorManualDataSelected.details.mtyP2}} | </span>
                                                <span v-if="motorManualDataSelected.details.mPr1!=null">{{motorManualDataSelected.details.mPr1}} kW | </span>
                                                <span v-if="motorManualDataSelected.details.mnr!=null">{{motorManualDataSelected.details.mnr}} Upm | </span>
                                                <span v-if="motorManualDataSelected.details.mU1!=null">{{motorManualDataSelected.details.mU1}} V | </span>
                                                <span v-if="motorManualDataSelected.details.mIr1!=null">{{motorManualDataSelected.details.mIr1}} A </span>
                                                <span v-if="motorManualDataSelected.details.mTypK!=null"> | {{motorManualDataSelected.details.mTypK}}</span>
                                            </div>
                                            <div>{{motorManualDataSelected.details.mN_MOT}}</div>
                                        </div>
                                        <div v-if="motorManualDataSelected.mklk!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">{{$t('3704')}}:</div>
                                            <div>
                                                <span v-if="motorManualDataSelected.mklk!=null && motorManualDataSelected.mklk.useTextKey==false">{{motorManualDataSelected.mklk.textUI}}</span>
                                                <span v-if="motorManualDataSelected.mklk!=null && motorManualDataSelected.mklk.useTextKey==true">{{$t(motorManualDataSelected.mklk.textKey)}}</span>
                                            </div>
                                            <div>
                                                <button v-if="motorManualDataSelected.alternativePartnumberMotorKLK!=null" class="btn my_btn_standard" @click="change_partNumberMklk(motorManualDataSelected)" style="padding: 0; margin-left: 10px; border:none !important"><span class="fa fa-exchange" style="font-size: 10px;padding:5px 5px 5px 5px"></span><span style="font-size: 14px; padding-right: 5px">{{$t('3705')}}</span></button>
                                            </div>
                                        </div>
                                        <div v-if="motorManualDataSelected.msart!=null&&motorManualDataSelected.msart.text!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">{{$t('3067')}}:</div>
                                            <div>
                                                <span v-if="motorManualDataSelected.msart!=null && motorManualDataSelected.msart.useTextKey==false">{{motorManualDataSelected.msart.textUI}}</span>
                                                <span v-if="motorManualDataSelected.msart!=null && motorManualDataSelected.msart.useTextKey==true">{{$t(motorManualDataSelected.msart.textKey)}}</span>
                                            </div>
                                        </div>
                                        <div v-if="motorManualDataSelected.msart!=null&&motorManualDataSelected.msart.text!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">{{$t('3455')}}:</div>
                                            <div>
                                                <span v-if="motorManualDataSelected.cnZert!=null && motorManualDataSelected.cnZert.useTextKey==false && motorManualDataSelected.cnZert.textUI != null">{{motorManualDataSelected.cnZert.textUI}} | </span>
                                                <span v-if="motorManualDataSelected.cnZert!=null && motorManualDataSelected.cnZert.useTextKey==true">{{$t(motorManualDataSelected.cnZert.textKey)}} | </span>
                                                <span v-if="motorManualDataSelected.details.bzert1!=null">{{motorManualDataSelected.details.bzert1}} | </span>
                                                <span v-if="motorManualDataSelected.details.bzerti!=null">{{motorManualDataSelected.details.bzerti}}</span>
                                            </div>
                                        </div>
                                        <div v-if="motorManualDataSelected.mfbtyp!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">{{$t('298')}}:</div>
                                            <div>
                                                <span v-if="motorManualDataSelected.mfbtyp!=null && motorManualDataSelected.mfbtyp.useTextKey==false">{{motorManualDataSelected.mfbtyp.textUI}}</span>
                                                <span v-if="motorManualDataSelected.mfbtyp!=null && motorManualDataSelected.mfbtyp.useTextKey==true">{{$t(motorManualDataSelected.mfbtyp.textKey)}}</span>
                                            </div>
                                            <div v-if="motorManualDataSelected.details.tnfb !=null">{{motorManualDataSelected.details.tnfb}}</div>
                                        </div>
                                        <div v-if="motorManualDataSelected.details.tnmlkt!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">{{$t('3604')}}:</div>
                                            <div> </div>
                                            <div>{{motorManualDataSelected.details.tnmlkt}}</div>
                                        </div>
                                        <div v-if="motorManualDataSelected.details.tnmskt!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">{{$t('3605')}}:</div>
                                            <div> </div>
                                            <div>{{motorManualDataSelected.details.tnmskt}}</div>
                                        </div>
                                        <div v-if="motorManualDataSelected.details.ltr!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">{{$t('411')}}:</div>
                                            <div>
                                                <span v-if="motorManualDataSelected.ltr!=null && motorManualDataSelected.ltr.useTextKey==false">{{motorManualDataSelected.ltr.textUI}}</span>
                                                <span v-if="motorManualDataSelected.ltr!=null && motorManualDataSelected.ltr.useTextKey==true">{{$t(motorManualDataSelected.ltr.textKey)}}</span>
                                                <span v-if="motorManualDataSelected.details.td!=null"> | {{motorManualDataSelected.details.td}} mm | </span>
                                                <span v-if="motorManualDataSelected.details.tb!=null">{{motorManualDataSelected.details.tb}} mm | </span>
                                                <span v-if="motorManualDataSelected.details.tdrz!=null&&motorManualDataSelected.details.tcsd!=null">{{motorManualDataSelected.details.tdrz}}x{{motorManualDataSelected.details.tcsd}} | </span>
                                                <span v-if="motorManualDataSelected.details.tauwi!=null">{{motorManualDataSelected.details.tauwi}} | </span>
                                                <span v-if="motorManualDataSelected.details.tauwi==null&&motorManualDataSelected.details.takwi!=null">{{motorManualDataSelected.details.takwi}} | </span>
                                                <span v-if="motorManualDataSelected.details.tarill!=null">{{motorManualDataSelected.details.tarill}} | </span>
                                                <span v-if="motorManualDataSelected.details.tdra!=null">{{motorManualDataSelected.details.tdra}}</span>
                                            </div>
                                            <div>
                                                <span v-if="motorManualDataSelected.details.mN_TS!=null">{{motorManualDataSelected.details.mN_TS}}</span>
                                            </div>
                                        </div>
                                        <div v-if="motorManualDataSelected.trro!=null&&motorManualDataSelected.trro.text!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">{{$t('1301')}}:</div>
                                            <div>
                                                <span v-if="motorManualDataSelected.trro!=null && motorManualDataSelected.trro.useTextKey==false">{{motorManualDataSelected.trro.textUI}}</span>
                                                <span v-if="motorManualDataSelected.trro!=null && motorManualDataSelected.trro.useTextKey==true">{{$t(motorManualDataSelected.trro.textKey)}}</span>
                                            </div>
                                            <div> </div>
                                        </div>
                                        <div v-if="motorManualDataSelected.trposmit!=null&&motorManualDataSelected.trposmit.text!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">{{$t('1301')}}:</div>
                                            <div>
                                                <span v-if="motorManualDataSelected.trposmit!=null && motorManualDataSelected.trposmit.useTextKey==false">{{motorManualDataSelected.trposmit.textUI}}</span>
                                                <span v-if="motorManualDataSelected.trposmit!=null && motorManualDataSelected.trposmit.useTextKey==true">{{$t(motorManualDataSelected.trposmit.textKey)}}</span>
                                            </div>
                                            <div> </div>
                                        </div>
                                        <div v-if="motorManualDataSelected.details.tnzbtr!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">{{$t('3462')}} {{$t('411')}}:</div>
                                            <div> </div>
                                            <div>{{motorManualDataSelected.details.tnzbtr}}</div>
                                        </div>
                                        <div v-if="motorManualDataSelected.details.mN_PASSFEDER!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">{{$t('3602')}}:</div>
                                            <div> </div>
                                            <div>{{motorManualDataSelected.details.mN_PASSFEDER}}</div>
                                        </div>
                                        <div v-if="motorManualDataSelected.tnabdi!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">Abdichtung:</div>
                                            <div> </div>
                                            <div>{{motorManualDataSelected.details.tnabdi}}</div>
                                        </div>
                                        <div v-if="motorManualDataSelected.details.tnhda!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">{{$t('3567')}}:</div>
                                            <div>
                                                <span v-if="motorManualDataSelected.lhda!=null && motorManualDataSelected.lhda.useTextKey==false">{{motorManualDataSelected.lhda.textUI}}</span>
                                                <span v-if="motorManualDataSelected.lhda!=null && motorManualDataSelected.lhda.useTextKey==true">{{$t(motorManualDataSelected.lhda.textKey)}}</span>
                                            </div>
                                            <div>{{motorManualDataSelected.details.tnhda}}</div>
                                        </div>
                                        <div v-if="motorManualDataSelected.details.lthd!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">Handrad:</div>
                                            <div>
                                                <span v-if="motorManualDataSelected.lthd!=null && motorManualDataSelected.lthd.useTextKey==false">{{motorManualDataSelected.lthd.textUI}}</span>
                                                <span v-if="motorManualDataSelected.lthd!=null && motorManualDataSelected.lthd.useTextKey==true">{{$t(motorManualDataSelected.lthd.textKey)}}</span>
                                            </div>
                                            <div>{{motorManualDataSelected.details.tnhd}}</div>
                                        </div>
                                        <div v-if="motorManualDataSelected.details.mN_ZBSEILSCHU!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">{{$t('3462')}} {{$t('3533')}}:</div>
                                            <div v-if="motorManualDataSelected.lseils!=null">
                                                <span v-if="motorManualDataSelected.lseils!=null && motorManualDataSelected.lseils.useTextKey==false">{{motorManualDataSelected.lseils.textUI}} | </span>
                                                <span v-if="motorManualDataSelected.lseils!=null && motorManualDataSelected.lseils.useTextKey==true">{{$t(motorManualDataSelected.lseils.textKey)}} | </span>
                                                <span v-if="motorManualDataSelected.fuesse!=null && motorManualDataSelected.fuesse.useTextKey==false">{{$t('1416')}} {{motorManualDataSelected.fuesse.textUI}} | </span>
                                                <span v-if="motorManualDataSelected.fuesse!=null && motorManualDataSelected.fuesse.useTextKey==true">{{$t('1416')}} {{$t(motorManualDataSelected.fuesse.textKey)}} | </span>
                                                <span v-if="motorManualDataSelected.seilab!=null && motorManualDataSelected.seilab.useTextKey==false">{{$t('3536')}} {{motorManualDataSelected.seilab.textUI}} | </span>
                                                <span v-if="motorManualDataSelected.seilab!=null && motorManualDataSelected.seilab.useTextKey==true">{{$t('3536')}} {{$t(motorManualDataSelected.seilab.textKey)}} | </span>
                                                <span v-if="motorManualDataSelected.einst!=null && motorManualDataSelected.einst.useTextKey==false">{{$t('3537')}} {{motorManualDataSelected.einst.textUI}}</span>
                                                <span v-if="motorManualDataSelected.einst!=null && motorManualDataSelected.einst.useTextKey==true">{{$t('3537')}} {{$t(motorManualDataSelected.einst.textKey)}}</span>
                                            </div>
                                            <div>{{motorManualDataSelected.details.mN_ZBSEILSCHU}}</div>
                                        </div>
                                        <div v-if="motorManualDataSelected.details.mN_SAS" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">{{$t('3538')}}:</div>
                                            <div> </div>
                                            <div>{{motorManualDataSelected.details.mN_SAS}}</div>
                                        </div>
                                        <div v-if="motorManualDataSelected.details.mN_TSAD!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">{{$t('3534')}}:</div>
                                            <div>
                                                <span v-if="motorManualDataSelected.ltsabd!=null && motorManualDataSelected.ltsabd.useTextKey==false">{{motorManualDataSelected.ltsabd.textUI}}</span>
                                                <span v-if="motorManualDataSelected.ltsabd!=null && motorManualDataSelected.ltsabd.useTextKey==true">{{$t(motorManualDataSelected.ltsabd.textKey)}}</span>
                                            </div>
                                            <div>{{motorManualDataSelected.details.mN_TSAD}}</div>
                                        </div>
                                        <div v-if="motorManualDataSelected.details.mN_TSKL!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">{{$t('3543')}}:</div>
                                            <div>
                                                <span v-if="motorManualDataSelected.ltklem!=null && motorManualDataSelected.ltklem.useTextKey==false">{{motorManualDataSelected.ltklem.textUI}}</span>
                                                <span v-if="motorManualDataSelected.ltklem!=null && motorManualDataSelected.ltklem.useTextKey==true">{{$t(motorManualDataSelected.ltklem.textKey)}}</span>
                                            </div>
                                            <div>{{motorManualDataSelected.details.mN_TSKL}}</div>
                                        </div>
                                        <div v-if="motorManualDataSelected.details.tnruev!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">{{$t('3586')}}:</div>
                                            <div> </div>
                                            <div>{{motorManualDataSelected.details.tnruev}}</div>
                                        </div>
                                    </div>
                                    <div v-if="motorManualDataSelected!=null">
                                        <div v-if="motorManualDataSelected.details.mN_BREM!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">{{$t('1396')}}:</div>
                                            <div>
                                                <span v-if="motorManualDataSelected.details.btyp!=null">{{motorManualDataSelected.details.btyp}} | </span>
                                                <span v-if="motorManualDataSelected.details.bcspan!=null">{{motorManualDataSelected.details.bcspan}} V | </span>
                                                <span v-if="motorManualDataSelected.bhl!=null && motorManualDataSelected.bhl.useTextKey==false">{{motorManualDataSelected.bhl.textUI}} | </span>
                                                <span v-if="motorManualDataSelected.bhl!=null && motorManualDataSelected.bhl.useTextKey==true">{{$t(motorManualDataSelected.bhl.textKey)}} | </span>
                                                <span v-if="motorManualDataSelected.bksich!=null && motorManualDataSelected.bksich.useTextKey==false">{{motorManualDataSelected.bksich.textUI}}</span>
                                                <span v-if="motorManualDataSelected.bksich!=null && motorManualDataSelected.bksich.useTextKey==true">{{$t(motorManualDataSelected.bksich.textKey)}}</span>
                                            </div>
                                            <div>{{motorManualDataSelected.details.mN_BREM}}</div>
                                        </div>
                                        <div v-if="motorManualDataSelected.details.tnzbb!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">{{$t('3462')}} {{$t('1396')}}:</div>
                                            <div><span v-if="motorManualDataSelected.details.szbans">{{motorManualDataSelected.details.szbans}}</span></div>
                                            <div>{{motorManualDataSelected.details.tnzbb}}</div>
                                        </div>
                                        <div v-if="motorManualDataSelected.details.tnbow!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">{{$t('3442')}}:</div>
                                            <div>

                                                <!--<span v-if="motorManualDataSelected.bowdenwireLength">{{motorManualDataSelected.details.bowdenwireLength}} m</span>-->
                                                <span v-if="motorManualDataSelected.lspezb!=null && motorManualDataSelected.lspezb.useTextKey==false">{{motorManualDataSelected.lspezb.textUI}}</span>
                                                <span v-if="motorManualDataSelected.lspezb!=null && motorManualDataSelected.lspezb.useTextKey==true">{{$t(motorManualDataSelected.lspezb.textKey)}}</span>
                                                <span v-if="motorManualDataSelected.details.spezbl!=null"> | {{motorManualDataSelected.details.spezbl}} m</span>
                                            </div>
                                            <div>{{motorManualDataSelected.details.tnbow}}</div>
                                        </div>
                                        <div v-if="motorManualDataSelected.details.llaghl!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">{{$t('3714')}}:</div>
                                            <div>{{motorManualDataSelected.details.llaghl}}&deg;</div>
                                            <div> </div>
                                        </div>
                                        <div v-if="motorManualDataSelected.details.mN_ENC!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">{{$t('3075')}}:</div>
                                            <div>{{motorManualDataSelected.details.gtyp}}</div>
                                            <div>{{motorManualDataSelected.details.mN_ENC}}</div>
                                        </div>
                                        <div v-if="motorManualDataSelected.details.mN_ENCADAPT!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">{{$t('3600')}}:</div>
                                            <div> </div>
                                            <div>{{motorManualDataSelected.details.mN_ENCADAPT}}</div>
                                        </div>
                                        <div class="my_color_00338e my_font-weight_600" style="padding: 5px;margin-top:5px">Weitere Baugruppen</div>
                                        <div v-if="motorManualDataSelected.details.tnlbab!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">Label AM Bremse:</div>
                                            <div> </div>
                                            <div>{{motorManualDataSelected.details.tnlbab}}</div>
                                        </div>
                                        <div v-if="motorManualDataSelected.details.tnlbof!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">Offsetlabel:</div>
                                            <div> </div>
                                            <div>{{motorManualDataSelected.details.tnlbof}}</div>
                                        </div>
                                        <div v-if="motorManualDataSelected.details.tnpgs!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">Steckerbeutel PSG:</div>
                                            <div> </div>
                                            <div>{{motorManualDataSelected.details.tnpgs}}</div>
                                        </div>
                                        <div v-if="motorManualDataSelected.details.mn_ZBSEILSCHU!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">Teilenumemr Seilschu:</div>
                                            <div> </div>
                                            <div>{{motorManualDataSelected.details.mN_ZBSEILSCHU}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="showAddOnPart==true">
                        <td style=" width: calc(100%/5); vertical-align: top">
                            <img src="../../../../public/img/ZAbrands/ZAsymbol.svg" style="width:70px" />
                        </td>

                        <td style=" width:calc(100%/5); vertical-align: top; padding-top:15px">
                            <h4 class="my_color_00338e my_font-weight_600">{{$t('3717')}}</h4>
                            <div class="my_color_00338e">{{$t('3457')}}, {{$t('3533')}}, {{$t('3441')}}, {{$t('3442')}}</div>
                        </td>

                        <td style=" width: calc(100%/5); vertical-align: top">
                            <button @click="ChangeAddOnPart()" class="btn my_btn_standard_blue" v-bind:disabled="showTemplateButton==true">{{$t('3464')}}</button>
                        </td>

                        <td v-if="motorManualDataSelected!=null&&showRopeGuardDetails==false" class="ZAfont_family ZAfont_size" style=" width:calc(100%/5*2); vertical-align: top">
                            <div>
                                <div>
                                    <div v-if="motorManualDataSelected.details.mip!=null" style="margin-left:5px">
                                        <span class="my_font-weight_600">{{$t('3457')}}:</span>
                                        <span> {{motorManualDataSelected.details.mip}}</span>
                                    </div>
                                    <div v-if="motorManualDataSelected.lseils!=null" style="margin-left:5px">
                                        <span class="my_font-weight_600">{{$t('3533')}}:</span>
                                        <span v-if="motorManualDataSelected.lseils!=null && motorManualDataSelected.lseils.useTextKey==false"> {{motorManualDataSelected.lseils.textUI}}</span>
                                        <span v-if="motorManualDataSelected.lseils!=null && motorManualDataSelected.lseils.useTextKey==true"> {{$t(motorManualDataSelected.lseils.textKey)}}</span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="motorManualDataSelected!=null">
                                <div>
                                    <button v-if="showRopeGuardDetails==false" @click="ChangeRopeGuardDetails(true)" class="btn my_btn_details">
                                        <span>&#9660; </span>
                                        <span class="my_color_00338e my_font-weight_600" style="padding: 5px;">{{$t('3240')}}</span>
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="showAddOnPart==true&&motorManualDataSelected!=null&&showRopeGuardDetails==true">
                        <td colspan="100" class="ZAfont_family ZAfont_size" style="vertical-align: top;">
                            <div>
                                <button @click="ChangeRopeGuardDetails(false)" class="btn my_btn_details">
                                    <span>&#9650; </span>
                                    <span class="my_color_00338e my_font-weight_600" style="padding: 5px;">{{$t('3240')}}</span>
                                </button>
                            </div>
                            <div>
                                <div>
                                    <div>
                                        <div v-if="motorManualDataSelected.details.mip!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">{{$t('3457')}}:</div>
                                            <div>{{motorManualDataSelected.details.mip}}</div>
                                            <div> </div>
                                        </div>
                                        <div v-if="motorManualDataSelected.details.mN_ZBSEILSCHU!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">{{$t('3533')}}:</div>
                                            <div v-if="motorManualDataSelected.lseils!=null">
                                                <span v-if="motorManualDataSelected.lseils!=null && motorManualDataSelected.lseils.useTextKey==false">{{motorManualDataSelected.lseils.textUI}} | </span>
                                                <span v-if="motorManualDataSelected.lseils!=null && motorManualDataSelected.lseils.useTextKey==true">{{$t(motorManualDataSelected.lseils.textKey)}} | </span>
                                                <span v-if="motorManualDataSelected.fuesse!=null && motorManualDataSelected.fuesse.useTextKey==false">{{$t('1416')}} {{motorManualDataSelected.fuesse.textUI}} | </span>
                                                <span v-if="motorManualDataSelected.fuesse!=null && motorManualDataSelected.fuesse.useTextKey==true">{{$t('1416')}} {{$t(motorManualDataSelected.fuesse.textKey)}} | </span>
                                                <span v-if="motorManualDataSelected.seilab!=null && motorManualDataSelected.seilab.useTextKey==false">{{$t('3536')}} {{motorManualDataSelected.seilab.textUI}} | </span>
                                                <span v-if="motorManualDataSelected.seilab!=null && motorManualDataSelected.seilab.useTextKey==true">{{$t('3536')}} {{$t(motorManualDataSelected.seilab.textKey)}} | </span>
                                                <span v-if="motorManualDataSelected.einst!=null && motorManualDataSelected.einst.useTextKey==false">{{$t('3537')}} {{motorManualDataSelected.einst.textUI}}</span>
                                                <span v-if="motorManualDataSelected.einst!=null && motorManualDataSelected.einst.useTextKey==true">{{$t('3537')}} {{$t(motorManualDataSelected.einst.textKey)}}</span>
                                            </div>
                                            <div>{{motorManualDataSelected.details.mN_ZBSEILSCHU}}</div>
                                        </div>
                                        <div v-if="motorManualDataSelected.details.mN_SAS" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">{{$t('3538')}}:</div>
                                            <div> </div>
                                            <div>{{motorManualDataSelected.details.mN_SAS}}</div>
                                        </div>
                                        <div v-if="motorManualDataSelected.details.mN_TSAD!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">{{$t('3534')}}:</div>
                                            <div>
                                                <span v-if="motorManualDataSelected.ltsabd!=null && motorManualDataSelected.ltsabd.useTextKey==false">{{motorManualDataSelected.ltsabd.textUI}}</span>
                                                <span v-if="motorManualDataSelected.ltsabd!=null && motorManualDataSelected.ltsabd.useTextKey==true">{{$t(motorManualDataSelected.ltsabd.textKey)}}</span>
                                            </div>
                                            <div>{{motorManualDataSelected.details.mN_TSAD}}</div>
                                        </div>
                                        <div v-if="motorManualDataSelected.details.mN_TSKL!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">{{$t('3543')}}:</div>
                                            <div>
                                                <span v-if="motorManualDataSelected.ltklem!=null && motorManualDataSelected.ltklem.useTextKey==false">{{motorManualDataSelected.ltklem.textUI}}</span>
                                                <span v-if="motorManualDataSelected.ltklem!=null && motorManualDataSelected.ltklem.useTextKey==true">{{$t(motorManualDataSelected.ltklem.textKey)}}</span>
                                            </div>
                                            <div>{{motorManualDataSelected.mN_TSKL}}</div>
                                        </div>
                                        <div v-if="motorManualDataSelected.details.tnruev!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">{{$t('3586')}}:</div>
                                            <div> </div>
                                            <div>{{motorManualDataSelected.details.tnruev}}</div>
                                        </div>
                                        <div v-if="motorManualDataSelected.details.tnzbb!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">{{$t('3462')}} {{$t('1396')}}:</div>
                                            <div> </div>
                                            <div>{{motorManualDataSelected.details.tnzbb}}</div>
                                        </div>
                                        <div v-if="motorManualDataSelected.details.tnbow!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                            <div class="my_font-weight_600">{{$t('3442')}}:</div>
                                            <div>

                                                <!--<span v-if="motorManualDataSelected.bowdenwireLength">{{motorManualDataSelected.details.bowdenwireLength}} m</span>-->
                                                <span v-if="motorManualDataSelected.lspezb!=null && motorManualDataSelected.lspezb.useTextKey==false">{{motorManualDataSelected.lspezb.textUI}}</span>
                                                <span v-if="motorManualDataSelected.lspezb!=null && motorManualDataSelected.lspezb.useTextKey==true">{{$t(motorManualDataSelected.lspezb.textKey)}}</span>
                                                <span v-if="motorManualDataSelected.details.spezbl!=null"> | {{motorManualDataSelected.details.spezbl}} m</span>
                                            </div>
                                            <div>{{motorManualDataSelected.details.tnbow}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="motorManualDataSelected!=null&&motorManualDataSelected.details.mN_MOT!=null">
                        <td style=" width: calc(100%/5); vertical-align: top">
                            <img src="../../../../public/img/ProductImages/Leitung/L-ML2.jpg" style="width:100px" />

                        </td>

                        <td style=" width: calc(100%/5); vertical-align: top">
                            <h4 class="my_color_00338e my_font-weight_600">{{$t('3028')}} {{$t('3435')}}</h4>
                        </td>

                        <td style=" width: calc(100%/5); vertical-align: top">
                            <button v-if="sapProfile==true" @click="MotorCables" class="btn my_btn_standard_blue" v-bind:disabled="showTemplateButton==true">{{$t('3464')}}</button>
                        </td>

                        <td v-if="showMotorCablesDetails==false&&motorCablesSelected!=null" class="ZAfont_family ZAfont_size" style=" width: calc(100%/5*2); vertical-align: top">
                            <div>
                                <div v-if="motorCablesSelected.encoderCableTypeDesignation!=null">
                                    <div class="my_fontWeight_600">{{$t('3436')}}:</div>
                                    <div style="margin-left:5px">
                                        <span>{{$t('407')}}:</span>
                                        <span style="margin-left:5px">{{motorCablesSelected.encoderCableTypeDesignation}}</span>
                                    </div>
                                </div>
                                <div v-if="motorCablesSelected.motorCableTypeDesignation!=null">
                                    <div class="my_fontWeight_600">{{$t('3437')}}:</div>
                                    <div style="margin-left:5px">
                                        <span>{{$t('407')}}:</span>
                                        <span style="margin-left:5px">{{motorCablesSelected.motorCableTypeDesignation}}</span>
                                    </div>
                                </div>
                                <div v-if="motorCablesSelected.motorProtectionCableTypeDesignation!=null">
                                    <div class="my_fontWeight_600">{{$t('3438')}}:</div>
                                    <div style="margin-left:5px">
                                        <span>{{$t('407')}}:</span>
                                        <span style="margin-left:5px">{{motorCablesSelected.motorProtectionCableTypeDesignation}}</span>
                                    </div>
                                </div>
                                <div v-if="motorCablesSelected.brakeCableTypeDesignation!=null">
                                    <div class="my_fontWeight_600">{{$t('3439')}}:</div>
                                    <div style="margin-left:5px">
                                        <span>{{$t('407')}}:</span>
                                        <span style="margin-left:5px">{{motorCablesSelected.brakeCableTypeDesignation}}</span>
                                    </div>
                                </div>
                                <div v-if="motorCablesSelected.brakeMonitoringCableTypeDesignation!=null">
                                    <div class="my_fontWeight_600">{{$t('3440')}}:</div>
                                    <div style="margin-left:5px">
                                        <span>{{$t('407')}}:</span>
                                        <span style="margin-left:5px">{{motorCablesSelected.brakeMonitoringCableTypeDesignation}}</span>
                                    </div>
                                </div>
                                <div v-if="motorCablesSelected.forcedVentilationCableTypeDesignation!=null">
                                    <div class="my_fontWeight_600">{{$t('3447')}}:</div>
                                    <div style="margin-left:5px">
                                        <span>{{$t('407')}}:</span>
                                        <span style="margin-left:5px">{{motorCablesSelected.forcedVentilationCableTypeDesignation}}</span>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div>
                                    <button @click="ChangeMotorCablesDetails(true)" class="btn my_btn_details">
                                        <span>&#9660; </span>
                                        <span class="my_color_00338e my_font-weight_600" style="padding: 5px;">{{$t('3240')}}</span>
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="motorCablesSelected!=null&&showMotorCablesDetails==true">
                        <td colspan="100" class="ZAfont_family ZAfont_size" style="vertical-align: top;">
                            <div>
                                <button @click="ChangeMotorCablesDetails(false)" class="btn my_btn_details">
                                    <span>&#9650; </span>
                                    <span class="my_color_00338e my_font-weight_600" style="padding: 5px;">{{$t('3240')}}</span>
                                </button>
                            </div>
                            <div>
                                <div>
                                    <div v-if="motorCablesSelected.details.tnlga!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3428')}}:</div>
                                        <div> </div>
                                        <div>{{motorCablesSelected.details.tnlga}}</div>
                                    </div>
                                    <div v-if="motorCablesSelected.details.tnlgl!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3436')}}:</div>
                                        <div v-if="motorCablesSelected.encoderCableTypeDesignation!=null">
                                            <span v-if="motorCablesSelected.llgl!=null && motorCablesSelected.llgl.useTextKey==false">{{motorCablesSelected.llgl.textUI}} | </span>
                                            <span v-if="motorCablesSelected.llgl!=null && motorCablesSelected.llgl.useTextKey==true">{{$t(motorCablesSelected.llgl.textKey)}} | </span>
                                            <span v-if="motorCablesSelected.details.sglMaN!=null">{{motorCablesSelected.details.sglMaN}} m | </span>
                                            <span>{{motorCablesSelected.encoderCableTypeDesignation}}</span>
                                        </div>
                                        <div>{{motorCablesSelected.details.tnlgl}}</div>
                                    </div>
                                    <div v-if="motorCablesSelected.details.tnlml!=null||motorCablesSelected.details.tnlmlf!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3437')}}:</div>
                                        <div v-if="motorCablesSelected.motorCableTypeDesignation!=null">
                                            <span v-if="motorCablesSelected.llml!=null && motorCablesSelected.llml.useTextKey==false">{{motorCablesSelected.llml.textUI}} | </span>
                                            <span v-if="motorCablesSelected.llml!=null && motorCablesSelected.llml.useTextKey==true">{{$t(motorCablesSelected.llml.textKey)}} | </span>
                                            <span v-if="motorCablesSelected.details.smlMaN!=null">{{motorCablesSelected.details.smlMaN}} m | </span>
                                            <span>{{motorCablesSelected.motorCableTypeDesignation}}</span>
                                        </div>
                                        <div>
                                            <span v-if="motorCablesSelected.details.tnlml!=null">{{motorCablesSelected.details.tnlml}}</span>
                                            <span v-if="motorCablesSelected.details.tnlmlf!=null">{{motorCablesSelected.details.tnlmlf}}</span>
                                        </div>
                                    </div>
                                    <div v-if="motorCablesSelected.details.tnlmsl!=null||motorCablesSelected.details.tnlmsf!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3438')}}:</div>
                                        <div v-if="motorCablesSelected.motorProtectionCableTypeDesignation!=null">
                                            <span v-if="motorCablesSelected.llms!=null && motorCablesSelected.llms.useTextKey==false">{{motorCablesSelected.llms.textUI}} | </span>
                                            <span v-if="motorCablesSelected.llms!=null && motorCablesSelected.llms.useTextKey==true">{{$t(motorCablesSelected.llms.textKey)}} | </span>
                                            <span v-if="motorCablesSelected.details.smsMaN!=null">{{motorCablesSelected.details.smsMaN}} m | </span>
                                            <span>{{motorCablesSelected.motorProtectionCableTypeDesignation}}</span>
                                        </div>
                                        <div>
                                            <span v-if="motorCablesSelected.details.tnlmsl!=null">{{motorCablesSelected.details.tnlmsl}}</span>
                                            <span v-if="motorCablesSelected.details.tnlmsf!=null">{{motorCablesSelected.details.tnlmsf}}</span>
                                        </div>
                                    </div>
                                    <div v-if="motorCablesSelected.mib1!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">MIb1:</div>
                                        <div>{{motorCablesSelected.mib1}} A</div>
                                    </div>
                                    <div v-if="motorCablesSelected.details.tnlba!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3439')}}:</div>
                                        <div v-if="motorCablesSelected.brakeCableTypeDesignation!=null">
                                            <span v-if="motorCablesSelected.llba!=null && motorCablesSelected.llba.useTextKey==false">{{motorCablesSelected.llba.textUI}} | </span>
                                            <span v-if="motorCablesSelected.llba!=null && motorCablesSelected.llba.useTextKey==true">{{$t(motorCablesSelected.llba.textKey)}} | </span>
                                            <span v-if="motorCablesSelected.details.sbaMaN!=null">{{motorCablesSelected.details.sbaMaN}} m | </span>
                                            <span>{{motorCablesSelected.brakeCableTypeDesignation}}</span>
                                        </div>
                                        <div>{{motorCablesSelected.details.tnlba}}</div>
                                    </div>
                                    <div v-if="motorCablesSelected.details.tnlbl!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3440')}}:</div>
                                        <div v-if="motorCablesSelected.brakeMonitoringCableTypeDesignation!=null">
                                            <span v-if="motorCablesSelected.llbl!=null && motorCablesSelected.llbl.useTextKey==false">{{motorCablesSelected.llbl.textUI}} | </span>
                                            <span v-if="motorCablesSelected.llbl!=null && motorCablesSelected.llbl.useTextKey==true">{{$t(motorCablesSelected.llbl.textKey)}} | </span>
                                            <span v-if="motorCablesSelected.details.sblMaN!=null">{{motorCablesSelected.details.sblMaN}} m | </span>
                                            <span>{{motorCablesSelected.brakeMonitoringCableTypeDesignation}}</span>
                                        </div>
                                        <div>{{motorCablesSelected.details.tnlbl}}</div>
                                    </div>
                                    <div v-if="motorCablesSelected.details.tnfLei!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3547')}}:</div>
                                        <div v-if="motorCablesSelected.fbCableTypeDesignation!=null">
                                            <span v-if="motorCablesSelected.llfbl!=null && motorCablesSelected.llfbl.useTextKey==false">{{motorCablesSelected.llfbl.textUI}} | </span>
                                            <span v-if="motorCablesSelected.llfbl!=null && motorCablesSelected.llfbl.useTextKey==true">{{$t(motorCablesSelected.llfbl.textKey)}} | </span>
                                            <span v-if="motorCablesSelected.details.sflMaN!=null">{{motorCablesSelected.details.sflMaN}} m | </span>
                                            <span>{{motorCablesSelected.fbCableTypeDesignation}}</span>
                                        </div>
                                        <div>{{motorCablesSelected.details.tnfLei}}</div>
                                    </div>
                                    <div class="my_color_00338e my_font-weight_600" style="padding: 5px;margin-top:5px">Weitere Baugruppen</div>
                                    <div v-if="motorCablesSelected.details.tnfbkv!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">Verschluss KV FB:</div>
                                        <div> </div>
                                        <div>{{motorCablesSelected.details.tnfbkv}}</div>
                                    </div>
                                    <div v-if="motorCablesSelected.details.tnlglv!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">Geberleitung-Verl�ngerung:</div>
                                        <div> </div>
                                        <div>{{motorCablesSelected.details.tnlglv}}</div>
                                    </div>
                                    <div v-if="motorCablesSelected.details.tnmlvr!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">Verschl. Reduk. ML:</div>
                                        <div> </div>
                                        <div>{{motorCablesSelected.details.tnmlvr}}</div>
                                    </div>
                                    <div v-if="motorCablesSelected.details.tnmsvr!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">Verschl. Reduk. MS:</div>
                                        <div> </div>
                                        <div>{{motorCablesSelected.details.tnmsvr}}</div>
                                    </div>
                                    <div v-if="motorCablesSelected.details.tntkkv!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">Verschluss MTK:</div>
                                        <div> </div>
                                        <div>{{motorCablesSelected.details.tntkkv}}</div>
                                    </div>
                                    <div v-if="motorCablesSelected.details.tnvlfb!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">Verbindungsleitung FB:</div>
                                        <div> </div>
                                        <div>{{motorCablesSelected.details.tnvlfb}}</div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="motorManualDataSelected!=null&&motorManualDataSelected.details.mN_MOT!=null">
                        <td style=" width: calc(100%/5); vertical-align: top">
                            <img src="../../../../public/img/ZAbrands/ZAsymbol.svg" style="width:70px" />
                        </td>
                        <td style=" width: calc(100%/5); vertical-align: top">
                            <h4 class="my_color_00338e my_font-weight_600">{{$t('3028')}} {{$t('3462')}}</h4>
                        </td>
                        <td style=" width: calc(100%/5); vertical-align: top">
                            <button v-if="sapProfile==true" @click="MotorSupplies" class="btn my_btn_standard_blue" v-bind:disabled="showTemplateButton==true">{{$t('3464')}}</button>
                        </td>

                        <td class="ZAfont_family ZAfont_size" style=" width: calc(100%/5*2); vertical-align: top">
                            <div v-if="motorSuppliesSelected!=null&&showMotorSuppliesDetails==false">
                                <div v-if="motorSuppliesSelected.details.mN_FARBE!=null">
                                    <div class="my_fontWeight_600">{{$t('3539')}}:</div>
                                    <div style="margin-left:5px">
                                        <span v-if="motorSuppliesSelected.farbe!=null && motorSuppliesSelected.farbe.useTextKey==false">{{motorSuppliesSelected.farbe.textUI}}</span>
                                        <span v-if="motorSuppliesSelected.farbe!=null && motorSuppliesSelected.farbe.useTextKey==true">{{$t(motorSuppliesSelected.farbe.textKey)}}</span>
                                        <span style="margin-left:10px">|</span>
                                        <span style="margin-left:10px">{{motorSuppliesSelected.details.mN_FARBE}}</span>
                                    </div>
                                </div>
                                <div v-if="motorSuppliesSelected.details.mN_BAL1!=null">
                                    <div class="my_fontWeight_600">{{$t('3390')}}:</div>
                                    <div style="margin-left:5px">
                                        <span v-if="motorSuppliesSelected.balsP1!=null && motorSuppliesSelected.balsP1.useTextKey==false">{{motorSuppliesSelected.balsP1.textUI}}</span>
                                        <span v-if="motorSuppliesSelected.balsP1!=null && motorSuppliesSelected.balsP1.useTextKey==true">{{$t(motorSuppliesSelected.balsP1.textKey)}}</span>
                                        <span v-if="motorSuppliesSelected.details.balmE1!=null"> | {{motorSuppliesSelected.details.balmE1}} {{$t('3078')}}</span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="motorSuppliesSelected!=null">
                                <div>
                                    <button v-if="showMotorSuppliesDetails==false" @click="ChangeMotorSuppliesDetails(true)" class="btn my_btn_details">
                                        <span>&#9660; </span>
                                        <span class="my_color_00338e my_font-weight_600" style="padding: 5px;">{{$t('3240')}}</span>
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="motorSuppliesSelected!=null&&showMotorSuppliesDetails==true">
                        <td colspan="100" class="ZAfont_family ZAfont_size" style="vertical-align: top;">
                            <div>
                                <button @click="ChangeMotorSuppliesDetails(false)" class="btn my_btn_details">
                                    <span>&#9650; </span>
                                    <span class="my_color_00338e my_font-weight_600" style="padding: 5px;">{{$t('3240')}}</span>
                                </button>
                            </div>
                            <div>
                                <div>
                                    <div v-if="motorSuppliesSelected.details.mN_FARBE!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3539')}}:</div>
                                        <div>
                                            <span v-if="motorSuppliesSelected.farbe!=null && motorSuppliesSelected.farbe.useTextKey==false">{{motorSuppliesSelected.farbe.textUI}}</span>
                                            <span v-if="motorSuppliesSelected.farbe!=null && motorSuppliesSelected.farbe.useTextKey==true">{{$t(motorSuppliesSelected.farbe.textKey)}}</span>
                                        </div>
                                        <div>{{motorSuppliesSelected.details.mN_FARBE}}</div>
                                    </div>
                                    <div v-if="motorSuppliesSelected.details.llab01!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3554')}} 1:</div>
                                        <div>
                                            <span>{{motorSuppliesSelected.details.llab01}}</span>
                                            <span v-if="motorSuppliesSelected.details.x_LSD!=null"> | {{motorSuppliesSelected.details.x_LSD}}</span>
                                        </div>
                                    </div>
                                    <div v-if="motorSuppliesSelected.details.mN_Logo!=null||motorSuppliesSelected.lLogo!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3540')}}:</div>
                                        <div>
                                            <span v-if="motorSuppliesSelected.lLogo!=null && motorSuppliesSelected.lLogo.useTextKey==false">{{motorSuppliesSelected.lLogo.textUI}}</span>
                                            <span v-if="motorSuppliesSelected.lLogo!=null && motorSuppliesSelected.lLogo.useTextKey==true">{{$t(motorSuppliesSelected.lLogo.textKey)}}</span>
                                            <span v-if="motorSuppliesSelected.details!=null&&motorSuppliesSelected.details.kulogo!=null"> | {{motorSuppliesSelected.details.kulogo}}</span>
                                        </div>
                                        <div v-if="motorSuppliesSelected.details.mN_Logo!=null">{{motorSuppliesSelected.details.mN_Logo}}</div>
                                    </div>
                                    <div v-if="motorSuppliesSelected.lbal!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3390')}}:</div>
                                        <div>
                                            <span v-if="motorSuppliesSelected.lbal!=null && motorSuppliesSelected.lbal.useTextKey==false">{{motorSuppliesSelected.lbal.textUI}}</span>
                                            <span v-if="motorSuppliesSelected.lbal!=null && motorSuppliesSelected.lbal.useTextKey==true">{{$t(motorSuppliesSelected.lbal.textKey)}}</span>
                                        </div>
                                        <div> </div>
                                    </div>
                                    <div v-if="motorSuppliesSelected.details.mN_BAL1!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3390')}}:</div>
                                        <div>
                                            <span v-if="motorSuppliesSelected.balsP1!=null && motorSuppliesSelected.balsP1.useTextKey==false">{{motorSuppliesSelected.balsP1.textUI}}</span>
                                            <span v-if="motorSuppliesSelected.balsP1!=null && motorSuppliesSelected.balsP1.useTextKey==true">{{$t(motorSuppliesSelected.balsP1.textKey)}}</span>
                                            <span v-if="motorSuppliesSelected.details.balmE1!=null"> | {{motorSuppliesSelected.details.balmE1}} {{$t('3078')}}</span>
                                        </div>
                                        <div>{{motorSuppliesSelected.details.mN_BAL1}}</div>
                                    </div>
                                    <div v-if="motorSuppliesSelected.details.mN_BAL2!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3390')}}:</div>
                                        <div>
                                            <span v-if="motorSuppliesSelected.balsP2!=null && motorSuppliesSelected.balsP2.useTextKey==false">{{motorSuppliesSelected.balsP2.textUI}}</span>
                                            <span v-if="motorSuppliesSelected.balsP2!=null && motorSuppliesSelected.balsP2.useTextKey==true">{{$t(motorSuppliesSelected.balsP2.textKey)}}</span>
                                            <span v-if="motorSuppliesSelected.details.balmE2!=null"> | {{motorSuppliesSelected.details.balmE2}} {{$t('3078')}}</span>
                                        </div>
                                        <div>{{motorSuppliesSelected.details.mN_BAL2}}</div>
                                    </div>
                                    <div v-if="motorSuppliesSelected.details.mN_BAL3!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3390')}}:</div>
                                        <div>
                                            <span v-if="motorSuppliesSelected.balsP3!=null && motorSuppliesSelected.balsP3.useTextKey==false">{{motorSuppliesSelected.balsP3.textUI}}</span>
                                            <span v-if="motorSuppliesSelected.balsP3!=null && motorSuppliesSelected.balsP3.useTextKey==true">{{$t(motorSuppliesSelected.balsP3.textKey)}}</span>
                                            <span v-if="motorSuppliesSelected.details.balmE3!=null"> | {{motorSuppliesSelected.details.balmE3}} {{$t('3078')}}</span>
                                        </div>
                                        <div>{{motorSuppliesSelected.details.mN_BAL3}}</div>
                                    </div>
                                    <div v-if="motorSuppliesSelected.details.tnkvml!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3541')}}:</div>
                                        <div> </div>
                                        <div>{{motorSuppliesSelected.details.tnkvml}}</div>
                                    </div>
                                    <div v-if="motorSuppliesSelected.details.mvLift!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('1053')}}:</div>
                                        <div>{{motorSuppliesSelected.details.mvLift}}</div>
                                    </div>
                                    <div v-if="motorSuppliesSelected.details.mis!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('1055')}}:</div>
                                        <div>{{motorSuppliesSelected.details.mis}}</div>
                                    </div>
                                    <div v-if="motorSuppliesSelected.details.onok!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3545')}}:</div>
                                        <div>{{motorSuppliesSelected.details.onok}}</div>
                                    </div>
                                    <div v-if="motorSuppliesSelected.details.inok!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3546')}}:</div>
                                        <div>{{motorSuppliesSelected.details.inok}}</div>
                                    </div>
                                    <div v-if="motorSuppliesSelected.details.projekt!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('1046')}}:</div>
                                        <div>{{motorSuppliesSelected.details.projekt}}</div>
                                    </div>
                                    <div v-if="motorSuppliesSelected.details.sanum!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3587')}}:</div>
                                        <div>{{motorSuppliesSelected.details.sanum}}</div>
                                    </div>
                                    <div v-if="motorSuppliesSelected.details.tnmk!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3618')}}:</div>
                                        <div>  </div>
                                        <div>{{motorSuppliesSelected.details.tnmk}}</div>
                                    </div>
                                    <div class="my_color_00338e my_font-weight_600" style="padding: 5px;margin-top:5px">Weitere Baugruppen</div>
                                    <div v-if="motorSuppliesSelected.details.tnbaa!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">BAL-Always:</div>
                                        <div> </div>
                                        <div>{{motorSuppliesSelected.details.tnbaa}}</div>
                                    </div>
                                    <div v-if="motorSuppliesSelected.details.tnbaB1!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">Anl. 1 Bowdenzug:</div>
                                        <div> </div>
                                        <div>{{motorSuppliesSelected.details.tnbaB1}}</div>
                                    </div>
                                    <div v-if="motorSuppliesSelected.details.tnbaB2!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">Anl. 2 Bowdenzug:</div>
                                        <div> </div>
                                        <div>{{motorSuppliesSelected.details.tnbaB2}}</div>
                                    </div>
                                    <div v-if="motorSuppliesSelected.details.tnbaB3!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">Anl. 3 Bowdenzug:</div>
                                        <div> </div>
                                        <div>{{motorSuppliesSelected.details.tnbaB3}}</div>
                                    </div>
                                    <div v-if="motorSuppliesSelected.details.tnbaR1!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">Anl. 1 Rueckholvori.:</div>
                                        <div> </div>
                                        <div>{{motorSuppliesSelected.details.tnbaR1}}</div>
                                    </div>
                                    <div v-if="motorSuppliesSelected.details.tnbaR2!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">Anl. 2 Rueckholvori.:</div>
                                        <div> </div>
                                        <div>{{motorSuppliesSelected.details.tnbaR2}}</div>
                                    </div>
                                    <div v-if="motorSuppliesSelected.details.tnbaR3!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">Anl. 3 Rueckholvori.:</div>
                                        <div> </div>
                                        <div>{{motorSuppliesSelected.details.tnbaR3}}</div>
                                    </div>
                                    <div v-if="motorSuppliesSelected.details.tnC4G!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">C4-Grundierung:</div>
                                        <div> </div>
                                        <div>{{motorSuppliesSelected.details.tnC4G}}</div>
                                    </div>
                                    <div v-if="motorSuppliesSelected.details.tnC4GH!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">C4-Grundierung-Haert:</div>
                                        <div> </div>
                                        <div>{{motorSuppliesSelected.details.tnC4GH}}</div>
                                    </div>
                                    <div v-if="motorSuppliesSelected.details.tnhaert!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">Teilenummer Haerter:</div>
                                        <div> </div>
                                        <div>{{motorSuppliesSelected.details.tnhaert}}</div>
                                    </div>
                                    <div v-if="motorSuppliesSelected.details.tniP24!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">Kleinteile IP24:</div>
                                        <div> </div>
                                        <div>{{motorSuppliesSelected.details.tniP24}}</div>
                                    </div>
                                    <div v-if="motorSuppliesSelected.details.mN_KDMAT1!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">Kundenteil 1:</div>
                                        <div> </div>
                                        <div>{{motorSuppliesSelected.details.mN_KDMAT1}}</div>
                                    </div>
                                    <div v-if="motorSuppliesSelected.details.mN_KDMAT2!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">Kundenteil 2:</div>
                                        <div> </div>
                                        <div>{{motorSuppliesSelected.details.mN_KDMAT2}}</div>
                                    </div>
                                    <div v-if="motorSuppliesSelected.details.mN_KDMAT3!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">Kundenteil 3:</div>
                                        <div> </div>
                                        <div>{{motorSuppliesSelected.details.mN_KDMAT3}}</div>
                                    </div>
                                    <div v-if="motorSuppliesSelected.details.tnlbcl!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">Label CEL:</div>
                                        <div> </div>
                                        <div>{{motorSuppliesSelected.details.tnlbcl}}</div>
                                    </div>
                                    <div v-if="motorSuppliesSelected.details.tnlbls!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">Label Leistungsschild:</div>
                                        <div> </div>
                                        <div>{{motorSuppliesSelected.details.tnlbls}}</div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="motorManualDataSelected!=null&&motorManualDataSelected.details.mN_MOT!=null">
                        <td style=" width: calc(100%/5); vertical-align: top">
                            <img src="../../../../public/img/ZAbrands/ZAsymbol.svg" style="width:70px" />
                        </td>
                        <td style=" width: calc(100%/5); vertical-align: top">
                            <h4 class="my_color_00338e my_font-weight_600">{{$t('3028')}} {{$t('3465')}}</h4>
                        </td>
                        <td style=" width: calc(100%/5); vertical-align: top">
                            <button v-if="sapProfile==true" @click="MotorPackaging" class="btn my_btn_standard_blue" v-bind:disabled="showTemplateButton==true">{{$t('3464')}}</button>
                        </td>

                        <td class="ZAfont_family ZAfont_size" style=" width: calc(100%/5*2); vertical-align: top">
                            <div v-if="motorPackagingSelected!=null&&showMotorPackagingDetails==false">
                                <div v-if="motorPackagingSelected.verp1!=null">
                                    <div class="my_fontWeight_600">{{$t('3465')}}:</div>
                                    <div style="margin-left:5px">
                                        <span v-if="motorPackagingSelected.verp1!=null && motorPackagingSelected.verp1.useTextKey==false">{{motorPackagingSelected.verp1.textUI}}</span>
                                        <span v-if="motorPackagingSelected.verp1!=null && motorPackagingSelected.verp1.useTextKey==true">{{$t(motorPackagingSelected.verp1.textKey)}}</span>
                                        <span style="margin-left:10px;margin-right:10px">|</span>
                                        <span v-if="motorPackagingSelected.verp2!=null && motorPackagingSelected.verp2.useTextKey==false">{{motorPackagingSelected.verp2.textUI}}</span>
                                        <span v-if="motorPackagingSelected.verp2!=null && motorPackagingSelected.verp2.useTextKey==true">{{$t(motorPackagingSelected.verp2.textKey)}}</span>
                                        <span style="margin-left:10px;margin-right:10px">|</span>
                                        <span v-if="motorPackagingSelected.verp3!=null && motorPackagingSelected.verp3.useTextKey==false">{{motorPackagingSelected.verp3.textUI}}</span>
                                        <span v-if="motorPackagingSelected.verp3!=null && motorPackagingSelected.verp3.useTextKey==true">{{$t(motorPackagingSelected.verp3.textKey)}}</span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="motorPackagingSelected!=null">
                                <div>
                                    <button v-if="showMotorPackagingDetails==false" @click="ChangeMotorPackagingDetails(true)" class="btn my_btn_details">
                                        <span>&#9660; </span>
                                        <span class="my_color_00338e my_font-weight_600" style="padding: 5px;">{{$t('3240')}}</span>
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="motorPackagingSelected!=null&&showMotorPackagingDetails==true">
                        <td colspan="100" class="ZAfont_family ZAfont_size" style="vertical-align: top;">
                            <div>
                                <button @click="ChangeMotorPackagingDetails(false)" class="btn my_btn_details">
                                    <span>&#9650; </span>
                                    <span class="my_color_00338e my_font-weight_600" style="padding: 5px;">{{$t('3240')}}</span>
                                </button>
                            </div>
                            <div>
                                <div>
                                    <div v-if="motorPackagingSelected.verp1!=null&&motorPackagingSelected.verp1.text!=null" style="display: grid; grid-template-columns: 1fr 3fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3465')}} 1:</div>
                                        <div>
                                            <span v-if="motorPackagingSelected.verp1!=null && motorPackagingSelected.verp1.useTextKey==false">{{motorPackagingSelected.verp1.textUI}}</span>
                                            <span v-if="motorPackagingSelected.verp1!=null && motorPackagingSelected.verp1.useTextKey==true">{{$t(motorPackagingSelected.verp1.textKey)}}</span>
                                        </div>
                                    </div>
                                    <div v-if="motorPackagingSelected.verp2!=null&&motorPackagingSelected.verp2.text!=null" style="display: grid; grid-template-columns: 1fr 3fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3465')}} 2:</div>
                                        <div>
                                            <span v-if="motorPackagingSelected.verp2!=null && motorPackagingSelected.verp2.useTextKey==false">{{motorPackagingSelected.verp2.textUI}}</span>
                                            <span v-if="motorPackagingSelected.verp2!=null && motorPackagingSelected.verp2.useTextKey==true">{{$t(motorPackagingSelected.verp2.textKey)}}</span>
                                        </div>
                                    </div>
                                    <div v-if="motorPackagingSelected.verp3!=null&&motorPackagingSelected.verp3.text!=null" style="display: grid; grid-template-columns: 1fr 3fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3465')}} 3:</div>
                                        <div>
                                            <span v-if="motorPackagingSelected.verp3!=null && motorPackagingSelected.verp3.useTextKey==false">{{motorPackagingSelected.verp3.textUI}}</span>
                                            <span v-if="motorPackagingSelected.verp3!=null && motorPackagingSelected.verp3.useTextKey==true">{{$t(motorPackagingSelected.verp3.textKey)}}</span>
                                        </div>
                                    </div>
                                    <div v-if="motorPackagingSelected.details.quantity!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3550')}}</div>
                                        <div>{{motorPackagingSelected.details.quantity}} {{$t('3078')}}</div>
                                    </div>
                                    <div v-if="motorPackagingSelected.details.quantity!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3543')}}</div>
                                        <div>{{motorPackagingSelected.details.quantityTKLEM}} {{$t('3078')}}</div>
                                    </div>
                                    <div v-if="motorPackagingSelected.details.quantityRuev!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3586')}}</div>
                                        <div>{{motorPackagingSelected.details.quantityRuev}} {{$t('3078')}}</div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td v-if="frameSelected!=null&&frameSelected.imagePath!=null&&frameSelected.imagePath!=''" style=" width: calc(100%/5); vertical-align: top">
                            <Images :imageFilePath="frameSelected.imagePath" :maxImageHeight="100" :maxImageWidth="100"></Images>
                        </td>
                        <td v-else style=" width: calc(100%/5); vertical-align: top">
                            <img src="../../../../public/img/ProductImages/ZAframe/ZAframe-MH/ZAframe-MH4000-frontcreative.jpg" style="width:100px" />
                        </td>

                        <td style=" width: calc(100%/5); vertical-align: top">
                            <h4 class="my_color_00338e my_font-weight_600">{{$t('1025')}}</h4>
                        </td>

                        <td style=" width:calc(100%/5); vertical-align: top">
                            <button v-if="sapProfile==true" @click="ZAframe" class="btn my_btn_standard_blue" v-bind:disabled="showTemplateButton==true">{{$t('3464')}}</button>
                            <button v-if="frameSelected!=null&&showTemplateButton==false&&plusManual==false&&zlwNumber==null" style="margin-left:5px;" @click="deleteFrame" class="btn my_btn_standard_blue" v-bind:disabled="showTemplateButton==true||plusManual==true">{{$t('3610')}}</button>
                        </td>

                        <td class="ZAfont_family ZAfont_size" style=" width: calc(100%/5*2); vertical-align: top">
                            <div v-if="frameSelected!=null&&showFrameDetails==false">
                                <div v-if="frameSelected.addOnPartInfo!=null&&frameSelected.addOnPartInfo.text!=null">
                                    <div class="my_fontWeight_600">{{$t('3618')}}:</div>
                                    <div style="margin-left:5px">
                                        <span v-if="frameSelected.addOnPartInfo!=null && frameSelected.addOnPartInfo.useTextKey==false">{{frameSelected.addOnPartInfo.textUI}}</span>
                                        <span v-if="frameSelected.addOnPartInfo!=null && frameSelected.addOnPartInfo.useTextKey==true">{{$t(frameSelected.addOnPartInfo.textKey)}}</span>
                                    </div>
                                </div>
                                <div v-if="frameSelected.fraart!=null&&frameSelected.fraart.text!=null">
                                    <div class="my_fontWeight_600">{{$t('3008')}}:</div>
                                    <div style="margin-left:5px">
                                        <span v-if="frameSelected.fraart!=null && frameSelected.fraart.useTextKey==false">{{frameSelected.fraart.textUI}}</span>
                                        <span v-if="frameSelected.fraart!=null && frameSelected.fraart.useTextKey==true">{{$t(frameSelected.fraart.textKey)}}</span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="frameSelected!=null">
                                <div>
                                    <button v-if="showFrameDetails==false" @click="ChangeFrameDetails(true)" class="btn my_btn_details">
                                        <span>&#9660; </span>
                                        <span class="my_color_00338e my_font-weight_600" style="padding: 5px;">{{$t('3240')}}</span>
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="frameSelected!=null&&frameSelected.details!=null&&showFrameDetails==true">
                        <td colspan="100" class="ZAfont_family ZAfont_size" style="vertical-align: top;">
                            <div>
                                <button @click="ChangeFrameDetails(false)" class="btn my_btn_details">
                                    <span>&#9650; </span>
                                    <span class="my_color_00338e my_font-weight_600" style="padding: 5px;">{{$t('3240')}}</span>
                                </button>
                            </div>
                            <div>
                                <div>
                                    <div v-if="frameSelected.addOnPartInfo!=null&&frameSelected.addOnPartInfo.text!=null&&frameSelected.details.tnmk!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3618')}}:</div>
                                        <div>
                                            <span v-if="frameSelected.addOnPartInfo!=null && frameSelected.addOnPartInfo.useTextKey==false">{{frameSelected.addOnPartInfo.textUI}}</span>
                                            <span v-if="frameSelected.addOnPartInfo!=null && frameSelected.addOnPartInfo.useTextKey==true">{{$t(frameSelected.addOnPartInfo.textKey)}}</span>
                                        </div>
                                        <div>{{frameSelected.details.tnmk}}</div>
                                    </div>
                                    <div v-if="frameSelected.fraart!=null&&frameSelected.fraart.text!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3008')}}:</div>
                                        <div>
                                            <span v-if="frameSelected.fraart!=null && frameSelected.fraart.useTextKey==false">{{frameSelected.fraart.textUI}}</span>
                                            <span v-if="frameSelected.fraart!=null && frameSelected.fraart.useTextKey==true">{{$t(frameSelected.fraart.textKey)}}</span>
                                            <span v-if="frameSelected.details.fratyp!=null"> | {{frameSelected.details.fratyp}}</span>
                                        </div>
                                        <div>{{frameSelected.details.ftnfrb}}</div>
                                    </div>
                                    <div v-if="frameSelected.details.positionLeft!=null&&frameSelected.details.positionLeft==1&&frameSelected.details.ftnfrl!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3701')}}:</div>
                                        <div>{{$t('271')}}</div>
                                        <div>{{frameSelected.details.ftnfrl}}</div>
                                    </div>
                                    <div v-if="frameSelected.details.positionRight!=null&&frameSelected.details.positionRight==1&&frameSelected.details.ftnfrr!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3700')}}:</div>
                                        <div>{{$t('270')}}</div>
                                        <div>{{frameSelected.details.ftnfrr}}</div>
                                    </div>
                                    <div v-if="frameSelected.mk!=null&&frameSelected.mk.text!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3396')}}:</div>
                                        <div>
                                            <span v-if="frameSelected.mk!=null && frameSelected.mk.useTextKey==false">{{frameSelected.mk.textUI}}</span>
                                            <span v-if="frameSelected.mk!=null && frameSelected.mk.useTextKey==true">{{$t(frameSelected.mk.textKey)}}</span>
                                        </div>
                                        <div v-if="frameSelected.details.ftnmk!=null">{{frameSelected.details.ftnmk}}</div>
                                    </div>
                                    <div v-if="frameSelected.details.ftnuR1!=null&&frameSelected.details.urd!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3413')}} 1:</div>
                                        <div>
                                            <span>{{$t('3038')}}: {{frameSelected.details.urd}} mm</span>
                                            <span v-if="frameSelected.details.urz!=null"> | {{$t('165')}}: {{frameSelected.details.urz}}</span>
                                        </div>                                        <div>{{frameSelected.details.ftnuR1}}</div>
                                    </div>
                                    <div v-if="frameSelected.details.ftnuR2!=null&&frameSelected.details.urd!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3413')}} 2:</div>
                                        <div>
                                            <span>{{$t('3038')}}: {{frameSelected.details.urd}} mm</span>
                                            <span v-if="frameSelected.details.urz!=null"> | {{$t('165')}}: {{frameSelected.details.urz}}</span>
                                        </div>
                                        <div>{{frameSelected.details.ftnuR2}}</div>
                                    </div>
                                    <div v-if="frameSelected.details.ftnret!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3386')}}:</div>
                                        <div></div>
                                        <div>{{frameSelected.details.ftnret}}</div>
                                    </div>
                                    <div v-if="frameSelected.details.ftnnot!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3387')}}:</div>
                                        <div></div>
                                        <div>{{frameSelected.details.ftnnot}}</div>
                                    </div>
                                    <div v-if="frameSelected.details.ftnsch!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3533')}} / {{$t('3388')}}:</div>
                                        <div></div>
                                        <div>{{frameSelected.details.ftnsch}}</div>
                                    </div>
                                    <div v-if="frameSelected.details.ftniso!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3389')}}:</div>
                                        <div></div>
                                        <div>{{frameSelected.details.ftniso}}</div>
                                    </div>
                                    <div v-if="frameSelected.bal!=null&&frameSelected.bal.text!=null" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                        <div class="my_font-weight_600">{{$t('3391')}}:</div>
                                        <div>
                                            <span v-if="frameSelected.bal!=null && frameSelected.bal.useTextKey==false">{{frameSelected.bal.textUI}}</span>
                                            <span v-if="frameSelected.bal!=null && frameSelected.bal.useTextKey==true">{{$t(frameSelected.bal.textKey)}}</span>
                                        </div>
                                        <div v-if="frameSelected.details.ftnbal!=null">{{frameSelected.details.ftnbal}}</div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td style=" width:calc(100%/5)">
                            <img src="../../../../public/img/ProductImages/ZAdyn4C/ZAdyn4C_011-032_ZD4C01M0-front.jpg" style="width:100px" />
                        </td>
                        <td style=" width:calc(100%/5)">
                            <h4 class="my_color_00338e my_font-weight_600">{{$t('3502')}}</h4>
                        </td>
                        <td style=" width:calc(100%/5)">
                            <button v-if="sapProfile==true" @click="ZAdyn" class="btn my_btn_standard_blue" style="margin-top: 5px;" v-bind:disabled="plusManual==true||showTemplateButton==true">{{$t('3464')}}</button>
                            <button v-if="Baug_Select != undefined&&showTemplateButton==false&&plusManual==false" style="margin-left: 5px; margin-top: 5px;" @click="deleteZAdyn" class="btn my_btn_standard_blue" v-bind:disabled="showTemplateButton==true||plusManual==true">{{$t('3610')}}</button>
                        </td>

                        <td style=" width:calc(100%/5)" class="ZAfont_family ZAfont_size">

                            <div v-if="Baug_Select != undefined && showInverterDetails==false">
                                <div v-if="Baug_Select != undefined">
                                    <span class=" my_font-weight_600">{{$t('3453')}}:</span>
                                    <span style="margin-left:5px">{{Baug_Select}}</span>
                                </div>
                                <!--<div v-if="Menue_Select != undefined">
                                <span class="my_color_00338e my_font-weight_600">Menuesprache:</span>
                                <span style="margin-left:5px">{{Menue_Select}}</span>
                            </div>-->

                            </div>
                            <div v-if="Baug_Select != undefined">

                                <div>
                                    <button v-if="showInverterDetails==false" @click="ChangeInverterDetails(true)" class="btn my_btn_details">
                                        <span>&#9660; </span>

                                        <span class="my_color_00338e my_font-weight_600" style="padding: 5px;">{{$t('3240')}}</span>

                                    </button>
                                </div>

                            </div>



                            <!--<div v-if="Baug_Select != undefined" class="my_color_00338e my_font-weight_600">{{$t('305')}}:</div>
                        <div v-if="Baug_Select != undefined">{{Baug_Select}}</div>
                        <div v-if="Menue_Select != undefined">{{Menue_Select}}</div>
                        <div v-if="Bal_Select != undefined">{{Bal_Select}}</div>
                        <div v-if="Par_Select != undefined">{{Par_Select}}</div>
                        <div v-if="Conf_Select != undefined">{{Conf_Select}}</div>
                        <div v-if="Code_Select != undefined">{{Code_Select}}</div>-->


                        </td>



                        <!--<td style=" width:calc(100%/5)">
                        <div v-if="PAD_Select != undefined || MON_Select != undefined || ND_Select != undefined || FEF_Select != undefined || BR_Select != undefined || BRLT_Select != undefined || DCP_Select != undefined || STO_Select != undefined || XOUT_Select != undefined || XIN_Select != undefined || Nachruestsatz_Select != undefined || ZAsbc_Select != undefined" class="my_color_00338e my_font-weight_600">{{$t('3527')}}:</div>
                        <div v-if="PAD_Select != undefined">{{PAD_Select}}</div>
                        <div v-if="MON_Select != undefined">{{MON_Select}}</div>
                        <div v-if="ND_Select != undefined">{{ND_Select}}</div>
                        <div v-if="FEF_Select != undefined">{{FEF_Select}}</div>
                        <div v-if="BR_Select != undefined">{{BR_Select}}</div>
                        <div v-if="BRLT_Select != undefined">{{BRLT_Select}}</div>
                        <div v-if="Nachruestsatz_Select != undefined">{{Nachruestsatz_Select}}</div>
                        <div v-if="DCP_Select != undefined">{{DCP_Select}}</div>
                        <div v-if="STO_Select != undefined">{{STO_Select}}</div>
                        <div v-if="XOUT_Select != undefined">{{XOUT_Select}}</div>
                        <div v-if="XIN_Select != undefined">{{XIN_Select}}</div>
                        <div v-if="ZAsbc_Select != undefined">{{ZAsbc_Select}}</div>
                        <div v-if="ZAsbc_LS_Select != undefined">{{ZAsbc_LS_Select}}</div>
                        <div v-if="ZAsbc_LSBA_Select != undefined">{{ZAsbc_LSBA_Select}}</div>
                        <div v-if="ZAsbc_BAL_Select != undefined">{{ZAsbc_BAL_Select}}</div>
                    </td>-->


                    </tr>
                    <tr v-if="showInverterDetails == true">

                        <td colspan="100" class="ZAfont_family ZAfont_size" style="vertical-align: top;">
                            <div>
                                <button @click="ChangeInverterDetails(false)" class="btn my_btn_details">
                                    <span>&#9650; </span>
                                    <span class="my_color_00338e my_font-weight_600" style="padding: 5px;">{{$t('3240')}}</span>
                                </button>
                            </div>
                            <div>

                                <div v-if="Baug_Select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">Anzahl Umrichter:</div>
                                    <div style="margin-left:5px">{{Menge}}</div>

                                </div>
                                <div v-if="Baug_Select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('3453')}}:</div>
                                    <div style="margin-left:5px">{{Baug_Select}}</div>
                                    <div style="margin-left:5px">{{MNFI_Select}}</div>
                                </div>
                                <div v-if="Menue_Select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('3509')}}:</div>
                                    <div style="margin-left:5px">{{Menue_Select}}</div>
                                </div>
                                <div v-if="Bal_Select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('3391')}}:</div>
                                    <div style="margin-left:5px">{{Bal_Select}}</div>
                                    <div style="margin-left:5px">{{MNBAL_Select}}</div>
                                </div>
                                <div v-if="Par_Select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('3510')}}:</div>
                                    <div style="margin-left:5px">{{Par_Select}}</div>
                                </div>
                                <div v-if="Conf_Select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('3511')}}:</div>
                                    <div style="margin-left:5px">{{Conf_Select}}</div>
                                </div>
                                <div v-if="Code_Select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('3512')}}:</div>
                                    <div style="margin-left:5px">{{Code_Select}}</div>
                                </div>
                                <div v-if="PAD_Select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('3513')}}:</div>
                                    <div style="margin-left:5px">{{PAD_Select}}</div>
                                    <div style="margin-left:5px">{{PADMN_Select}}</div>
                                </div>
                                <div v-if="MON_Select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('3514')}}:</div>
                                    <div style="margin-left:5px">{{MON_Select}}</div>
                                    <div style="margin-left:5px">{{MONMN_Select}}</div>
                                </div>
                                <div v-if="ND_Select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('3515')}}:</div>
                                    <div style="margin-left:5px">{{ND_Select}}</div>
                                    <div style="margin-left:5px">{{NDMN_Select}}</div>
                                </div>
                                <div v-if="FEF_Select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('3516')}}:</div>
                                    <div style="margin-left:5px">{{FEF_Select}}</div>
                                    <div style="margin-left:5px">{{FEFMN_Select}}</div>
                                </div>
                                <div v-if="Rueckspeisung_Select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('361')}}:</div>
                                    <div style="margin-left:5px">{{Rueckspeisung_Select}}</div>

                                </div>
                                <div v-if="BR_Select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('388')}}:</div>
                                    <div style="margin-left:5px">{{BR_Select}}</div>
                                    <div style="margin-left:5px">{{BRMN_Select}}</div>
                                </div>
                                <div v-if="BRLT_Select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('3517')}}:</div>
                                    <div style="margin-left:5px">{{BRLT_Select}}</div>
                                    <div style="margin-left:5px">{{BRLTMN_Select}}</div>
                                </div>
                                <div v-if="Nachruestsatz_Select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('3518')}}:</div>
                                    <div style="margin-left:5px">{{Nachruestsatz_Select}}</div>
                                    <div style="margin-left:5px">{{NachruestsatzMN_Select}}</div>
                                </div>
                                <div v-if="Nachruestsatz_Platte_Select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('3518')}} Platte:</div>
                                    <div style="margin-left:5px">{{Nachruestsatz_Platte_Select}}</div>
                                    <div style="margin-left:5px">{{NachruestsatzMN_Platte_Select}}</div>
                                </div>
                                <div v-if="DCP_Select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('3519')}}:</div>
                                    <div style="margin-left:5px">{{DCP_Select}}</div>
                                    <div style="margin-left:5px">{{DCPMN_Select}}</div>
                                </div>
                                <div v-if="STO_Select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('3520')}}:</div>
                                    <div style="margin-left:5px">{{STO_Select}}</div>
                                    <div style="margin-left:5px">{{STOMN_Select}}</div>
                                </div>
                                <div v-if="XOUT_Select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('3521')}}:</div>
                                    <div style="margin-left:5px">{{XOUT_Select}}</div>
                                    <div style="margin-left:5px">{{XOUTMN_Select}}</div>
                                </div>
                                <div v-if="XIN_Select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('3522')}}:</div>
                                    <div style="margin-left:5px">{{XIN_Select}}</div>
                                    <div style="margin-left:5px">{{XINMN_Select}}</div>
                                </div>
                                <div v-if="ZAsbc_Select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('3523')}}:</div>
                                    <div style="margin-left:5px">{{ZAsbc_Select}}</div>
                                    <div style="margin-left:5px">{{ZAsbcMN_Select}}</div>
                                </div>
                                <div v-if="ZAsbc_LS_Select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('3524')}}:</div>
                                    <div style="margin-left:5px">{{ZAsbc_LS_Select}}</div>
                                    <div style="margin-left:5px">{{ZAsbc_LSMN_Select}}</div>
                                </div>
                                <div v-if="ZAsbc_LSBA_Select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('3525')}}:</div>
                                    <div style="margin-left:5px">{{ZAsbc_LSBA_Select}}</div>
                                    <div style="margin-left:5px">{{ZAsbc_LSBAMN_Select}}</div>
                                </div>
                                <div v-if="ZAsbc_BAL_Select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('3391')}} {{$t('3523')}}:</div>
                                    <div style="margin-left:5px">{{ZAsbc_BAL_Select}}</div>
                                    <div style="margin-left:5px">{{ZAsbc_BALMN_Select}}</div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td style=" width:calc(100%/5)">
                            <img src="../../../../public/img/ProductImages/EVAC_3/EVAC-3C_NOMARK-front.jpg" style="width:100px" />

                        </td>

                        <td style=" width:calc(100%/5)">

                            <h4 class="my_color_00338e my_font-weight_600">{{$t('3500')}}</h4>
                        </td>

                        <td style=" width:calc(100%/5)">
                            <button v-if="sapProfile==true" @click="EVAC" class="btn my_btn_standard_blue" style="margin-top: 5px;" v-bind:disabled="plusManual==true||showTemplateButton==true">{{$t('3464')}}</button>
                            <button v-if="EVAC_Typ_select != undefined&&showTemplateButton==false&&plusManual==false" style="margin-left: 5px; margin-top: 5px;" @click="deleteEVAC" class="btn my_btn_standard_blue" v-bind:disabled="showTemplateButton==true||plusManual==true">{{$t('3610')}}</button>
                        </td>


                        <td style=" width:calc(100%/5)" class="ZAfont_family ZAfont_size">

                            <div v-if="EVAC_Typ_select != undefined && showEVACDetails==false">
                                <div v-if="EVAC_Typ_select != undefined">
                                    <span class="my_font-weight_600">{{$t('3453')}}:</span>
                                    <span style="margin-left:5px">{{EVAC_Typ_select}}</span>
                                </div>

                            </div>
                            <div v-if="EVAC_Typ_select != undefined">
                                <div>
                                    <button v-if="showEVACDetails==false" @click="ChangeEVACDetails(true)" class="btn my_btn_details">
                                        <span>&#9660; </span>
                                        <span class="my_color_00338e my_font-weight_600" style="padding: 5px;">{{$t('3240')}}</span>
                                    </button>
                                </div>
                            </div>




                        </td>

                        <td style=" width:calc(100%/5)">
                        </td>
                    </tr>

                    <tr v-if="showEVACDetails == true">
                        <td colspan="100" class="ZAfont_family ZAfont_size" style="vertical-align: top;">
                            <div>

                                <button @click="ChangeEVACDetails(false)" class="btn my_btn_details">
                                    <span>&#9650; </span>
                                    <span class="my_color_00338e my_font-weight_600" style="padding: 5px;">{{$t('3240')}}</span>
                                </button>
                            </div>
                            <div>

                                <div v-if="EVAC_Typ_select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">Anzahl EVAC:</div>
                                    <div style="margin-left:5px">{{MengeEVAC}}</div>

                                </div>
                                <div v-if="EVAC_Typ_select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('3453')}}:</div>
                                    <div style="margin-left:5px">{{EVAC_Typ_select}}</div>
                                    <div style="margin-left:5px">{{EVAC_TypMN_select}}</div>
                                </div>
                                <div v-if="EVAC_Batt_select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('3505')}}:</div>
                                    <div style="margin-left:5px">{{EVAC_Batt_select}}</div>
                                    <div style="margin-left:5px">{{EVAC_BattMN_select}}</div>
                                </div>
                                <div v-if="EVAC_Cable_select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('3506')}}:</div>
                                    <div style="margin-left:5px">{{EVAC_Cable_select}}</div>
                                    <div style="margin-left:5px">{{EVAC_CableMN_select}}</div>
                                </div>
                                <div v-if="EVAC_Control_Cable_select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('3507')}}:</div>
                                    <div style="margin-left:5px">{{EVAC_Control_Cable_select}}</div>
                                    <div style="margin-left:5px">{{EVAC_Control_CableMN_select}}</div>
                                </div>
                                <div v-if="EVAC_Bal_select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('3391')}}:</div>
                                    <div style="margin-left:5px">{{EVAC_Bal_select}}</div>
                                    <div style="margin-left:5px">{{EVAC_BalMN_select}}</div>
                                </div>
                            </div>
                        </td>
                    </tr>



                    <tr>
                        <td style=" width:calc(100%/5)">


                            <img src="../../../../public/img/ProductImages/ZArec/ZArec4C_013_ZDRE01M0-front.jpg" style="width:100px" />

                        </td>

                        <td style=" width:calc(100%/5)">

                            <h4 class="my_color_00338e my_font-weight_600">{{$t('361')}}</h4>
                        </td>

                        <td style=" width:calc(100%/5)">

                            <button v-if="sapProfile==true" @click="ZArec" class="btn my_btn_standard_blue" style="margin-top: 5px;" v-bind:disabled="plusManual==true||showTemplateButton==true">{{$t('3464')}}</button>
                            <button v-if="ZArec_Typ_select != undefined&&showTemplateButton==false&&plusManual==false" style="margin-left: 5px; margin-top: 5px; " @click="deleteZArec" class="btn my_btn_standard_blue" v-bind:disabled="showTemplateButton==true||plusManual==true">{{$t('3610')}}</button>
                        </td>

                        <td style=" width:calc(100%/5)" class="ZAfont_family ZAfont_size">

                            <div v-if="ZArec_Typ_select != undefined && showZArecDetails==false">
                                <div v-if="ZArec_Typ_select != undefined">
                                    <span class="my_font-weight_600">{{$t('3453')}}:</span>
                                    <span style="margin-left:5px">{{ZArec_Typ_select}}</span>
                                </div>

                            </div>
                            <div v-if="ZArec_Typ_select != undefined">
                                <div>
                                    <button v-if="showZArecDetails==false" @click="ChangeZArecDetails(true)" class="btn my_btn_details">
                                        <span>&#9660; </span>
                                        <span class="my_color_00338e my_font-weight_600" style="padding: 5px;">{{$t('3240')}}</span>
                                    </button>
                                </div>
                            </div>

                        </td>

                        <td style=" width:calc(100%/5)">
                        </td>
                    </tr>



                    <tr v-if="showZArecDetails == true">
                        <td colspan="100" class="ZAfont_family ZAfont_size" style="vertical-align: top;">
                            <div>

                                <button @click="ChangeZArecDetails(false)" class="btn my_btn_details">
                                    <span>&#9650; </span>
                                    <span class="my_color_00338e my_font-weight_600" style="padding: 5px;">{{$t('3240')}}</span>
                                </button>
                            </div>
                            <div v-if="EVAC_Typ_select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                <div class=" my_font-weight_600">Anzahl ZArec/RLD:</div>
                                <div style="margin-left:5px">{{MengeZArec}}</div>

                            </div>
                            <div>
                                <div v-if="ZArec_Typ_select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('3453')}}:</div>
                                    <div style="margin-left:5px">{{ZArec_Typ_select}}</div>
                                    <div style="margin-left:5px">{{ZArec_TypMN_select}}</div>
                                </div>
                                <div v-if="ZArec_LS_select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('3588')}}:</div>
                                    <div style="margin-left:5px">{{ZArec_LS_select}}</div>
                                    <div style="margin-left:5px">{{ZArec_LSMN_select}}</div>
                                </div>

                                <div v-if="ZArec_BR_select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('388')}}:</div>
                                    <div style="margin-left:5px">{{ZArec_BR_select}}</div>
                                    <div style="margin-left:5px">{{ZArec_BRMN_select}}</div>
                                </div>
                                <div v-if="ZArec_BRLT_select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('3517')}}:</div>
                                    <div style="margin-left:5px">{{ZArec_BRLT_select}}</div>
                                    <div style="margin-left:5px">{{ZArec_BRLTMN_select}}</div>
                                </div>
                                <div v-if="ZArec_ZApad_select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('3513')}}:</div>
                                    <div style="margin-left:5px">{{ZArec_ZApad_select}}</div>
                                    <div style="margin-left:5px">{{ZArec_ZApadMN_select}}</div>
                                </div>
                                <div v-if="ZArec_BAL_select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('3391')}}:</div>
                                    <div style="margin-left:5px">{{ZArec_BAL_select}}</div>
                                    <div style="margin-left:5px">{{ZArec_BALMN_select}}</div>
                                </div>
                                <div v-if="RLD_Typ_select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('407')}}:</div>
                                    <div style="margin-left:5px">{{RLD_Typ_select}}</div>
                                    <div style="margin-left:5px">{{RLD_TypMN_select}}</div>
                                </div>
                                <div v-if="RLD_FEF_select != undefined" style="display: grid; grid-template-columns: 1fr 2fr 1fr; padding: 5px">
                                    <div class=" my_font-weight_600">{{$t('3516')}}:</div>
                                    <div style="margin-left:5px">{{RLD_FEF_select}}</div>
                                    <div style="margin-left:5px">{{RLD_FEFMN_select}}</div>
                                </div>
                            </div>
                        </td>
                    </tr>


                    <tr>
                        <td style=" width:calc(100%/5)">


                            <!-- <img src="../../../../public/img/ProductImages" style="width:100px" />-->
                        </td>

                        <!--<td style=" width:calc(100%/5)">

                        <h4 class="my_color_00338e my_font-weight_600">RLD</h4>
                    </td>

                    <td style=" width:calc(100%/5)">

                        <button v-if="sapProfile==true" @click="RLD" class="btn my_btn_standard_blue">{{$t('3298')}}</button>
                    </td>-->
                        <td style=" width:calc(100%/5)">
                        </td>

                        <td style=" width:calc(100%/5)">
                        </td>
                    </tr>

                </table>
            </div>
            <div v-if="plusManual==true" style="margin-left: 0px; margin-right:0px">
                <SummaryInformationManual :additional="true"></SummaryInformationManual>
            </div>
            <div v-if="plusManual==false" style="margin-left: 0px; margin-right:0px">
                <div v-if="motorManualDataSelected!=null">
                    <button @click="informationAtkonf" class="btn my_btn_standard_blue">{{$t('3177')}} ATKONF</button>
                </div>
                <SummaryInformationManual :additional="false"></SummaryInformationManual>
            </div>
        </div>
        <div class="my_modal" v-bind:class="{show: showAtkonfDifferencePartNumbers==true}" align="center">
            <div class="my_modal-dialog size-md" style="height:100px">
                <div class="my_modal-content">
                    <div class="my_modal-header">
                        <div class="my_fontSize_1Point5 my_fontWeight_600 my_color_00338e ZAfont_family">{{$t('3709')}}</div>
                        <div>
                            <span @click="closeAtkonfDifferencePartNumbers(false)" class="fal fa-times fa-2x"></span>
                        </div>
                    </div>
                    <div class="my_modal-body" style="max-height: calc(100vh - 150px)">
                        <div v-if="atkonfDifferencePartNumbers!=null" style="margin-bottom: 10px; margin-top: 5px">
                            <table style="border-collapse: collapse; width:95%;" class="ZAfont_size ZAfont_family">
                                <tr class="my_background-color_00338e">
                                    <th class="my_tableAtkonf_cell text-left my_color_ffffff"> </th>
                                    <th class="my_tableAtkonf_cell text-right my_color_ffffff">{{$t('3707')}} {{$t('3427')}}</th>
                                    <th class="my_tableAtkonf_cell text-right my_color_ffffff"> </th>
                                    <th class="my_tableAtkonf_cell text-right my_color_ffffff">{{$t('3708')}} {{$t('3427')}}</th>
                                </tr>
                                <tr style="border-bottom: 1px solid grey;">
                                    <td class="my_tableAtkonf_cell text-left my_font-weight_600">{{$t('1098')}}</td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnmot.old!=null">{{atkonfDifferencePartNumbers.tnmot.old}}</span></td>
                                    <td class="my_tableAtkonf_cell text-right my_color_c7066e"> <span v-if="atkonfDifferencePartNumbers.tnmot.difference==true">!! </span> </td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnmot.current!=null">{{atkonfDifferencePartNumbers.tnmot.current}}</span></td>
                                </tr>
                                <tr style="border-bottom: 1px solid grey;">
                                    <td class="my_tableAtkonf_cell text-left my_font-weight_600">{{$t('3626')}}</td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnfb.old!=null">{{atkonfDifferencePartNumbers.tnfb.old}}</span></td>
                                    <td class="my_tableAtkonf_cell text-right my_color_c7066e"> <span v-if="atkonfDifferencePartNumbers.tnfb.difference==true">!! </span> </td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnfb.current!=null">{{atkonfDifferencePartNumbers.tnfb.current}}</span></td>
                                </tr>
                                <tr style="border-bottom: 1px solid grey;">
                                    <td class="my_tableAtkonf_cell text-left my_font-weight_600">{{$t('1301')}}</td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tntr.old!=null">{{atkonfDifferencePartNumbers.tntr.old}}</span></td>
                                    <td class="my_tableAtkonf_cell text-right my_color_c7066e"> <span v-if="atkonfDifferencePartNumbers.tntr.difference==true">!! </span> </td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tntr.current!=null">{{atkonfDifferencePartNumbers.tntr.current}}</span></td>
                                </tr>
                                <tr style="border-bottom: 1px solid grey;">
                                    <td class="my_tableAtkonf_cell text-left my_font-weight_600">{{$t('3533')}}</td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnzbs.old!=null">{{atkonfDifferencePartNumbers.tnzbs.old}}</span></td>
                                    <td class="my_tableAtkonf_cell text-right my_color_c7066e"> <span v-if="atkonfDifferencePartNumbers.tnzbs.difference==true">!! </span> </td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnzbs.current!=null">{{atkonfDifferencePartNumbers.tnzbs.current}}</span></td>
                                </tr>
                                <tr style="border-bottom: 1px solid grey;">
                                    <td class="my_tableAtkonf_cell text-left my_font-weight_600">{{$t('3534')}}</td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tntsad.old!=null">{{atkonfDifferencePartNumbers.tntsad.old}}</span></td>
                                    <td class="my_tableAtkonf_cell text-right my_color_c7066e"> <span v-if="atkonfDifferencePartNumbers.tntsad.difference==true">!! </span> </td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tntsad.current!=null">{{atkonfDifferencePartNumbers.tntsad.current}}</span></td>
                                </tr>
                                <tr style="border-bottom: 1px solid grey;">
                                    <td class="my_tableAtkonf_cell text-left my_font-weight_600">{{$t('1396')}}</td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnbrem.old!=null">{{atkonfDifferencePartNumbers.tnbrem.old}}</span></td>
                                    <td class="my_tableAtkonf_cell text-right my_color_c7066e"> <span v-if="atkonfDifferencePartNumbers.tnbrem.difference==true">!! </span> </td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnbrem.current!=null">{{atkonfDifferencePartNumbers.tnbrem.current}}</span></td>
                                </tr>
                                <tr style="border-bottom: 1px solid grey;">
                                    <td class="my_tableAtkonf_cell text-left my_font-weight_600">{{$t('3462')}} {{$t('1396')}}</td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnzbb.old!=null">{{atkonfDifferencePartNumbers.tnzbb.old}}</span></td>
                                    <td class="my_tableAtkonf_cell text-right my_color_c7066e"> <span v-if="atkonfDifferencePartNumbers.tnzbb.difference==true">!! </span> </td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnzbb.current!=null">{{atkonfDifferencePartNumbers.tnzbb.current}}</span></td>
                                </tr>
                                <tr style="border-bottom: 1px solid grey;">
                                    <td class="my_tableAtkonf_cell text-left my_font-weight_600">{{$t('3442')}}</td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnbow.old!=null">{{atkonfDifferencePartNumbers.tnbow.old}}</span></td>
                                    <td class="my_tableAtkonf_cell text-right my_color_c7066e"> <span v-if="atkonfDifferencePartNumbers.tnbow.difference==true">!! </span> </td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnbow.current!=null">{{atkonfDifferencePartNumbers.tnbow.current}}</span></td>
                                </tr>
                                <tr style="border-bottom: 1px solid grey;">
                                    <td class="my_tableAtkonf_cell text-left my_font-weight_600">{{$t('3075')}}</td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tngeb.old!=null">{{atkonfDifferencePartNumbers.tngeb.old}}</span></td>
                                    <td class="my_tableAtkonf_cell text-right my_color_c7066e"> <span v-if="atkonfDifferencePartNumbers.tngeb.difference==true">!! </span> </td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tngeb.current!=null">{{atkonfDifferencePartNumbers.tngeb.current}}</span></td>
                                </tr>
                                <tr style="border-bottom: 1px solid grey;">
                                    <td class="my_tableAtkonf_cell text-left my_font-weight_600">{{$t('3428')}}</td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnlga.old!=null">{{atkonfDifferencePartNumbers.tnlga.old}}</span></td>
                                    <td class="my_tableAtkonf_cell text-right my_color_c7066e"> <span v-if="atkonfDifferencePartNumbers.tnlga.difference==true">!! </span> </td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnlga.current!=null">{{atkonfDifferencePartNumbers.tnlga.current}}</span></td>
                                </tr>
                                <tr style="border-bottom: 1px solid grey;">
                                    <td class="my_tableAtkonf_cell text-left my_font-weight_600">{{$t('3436')}}</td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnlgl.old!=null">{{atkonfDifferencePartNumbers.tnlgl.old}}</span></td>
                                    <td class="my_tableAtkonf_cell text-right my_color_c7066e"> <span v-if="atkonfDifferencePartNumbers.tnlgl.difference==true">!! </span> </td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnlgl.current!=null">{{atkonfDifferencePartNumbers.tnlgl.current}}</span></td>
                                </tr>
                                <tr style="border-bottom: 1px solid grey;">
                                    <td class="my_tableAtkonf_cell text-left my_font-weight_600">{{$t('3437')}}</td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnlml.old!=null">{{atkonfDifferencePartNumbers.tnlml.old}}</span></td>
                                    <td class="my_tableAtkonf_cell text-right my_color_c7066e"> <span v-if="atkonfDifferencePartNumbers.tnlml.difference==true">!! </span> </td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnlml.current!=null">{{atkonfDifferencePartNumbers.tnlml.current}}</span></td>
                                </tr>
                                <tr style="border-bottom: 1px solid grey;">
                                    <td class="my_tableAtkonf_cell text-left my_font-weight_600">{{$t('3438')}}</td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnlmsl.old!=null">{{atkonfDifferencePartNumbers.tnlmsl.old}}</span></td>
                                    <td class="my_tableAtkonf_cell text-right my_color_c7066e"> <span v-if="atkonfDifferencePartNumbers.tnlmsl.difference==true">!! </span> </td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnlmsl.current!=null">{{atkonfDifferencePartNumbers.tnlmsl.current}}</span></td>
                                </tr>
                                <tr style="border-bottom: 1px solid grey;">
                                    <td class="my_tableAtkonf_cell text-left my_font-weight_600">{{$t('3439')}}</td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnlba.old!=null">{{atkonfDifferencePartNumbers.tnlba.old}}</span></td>
                                    <td class="my_tableAtkonf_cell text-right my_color_c7066e"> <span v-if="atkonfDifferencePartNumbers.tnlba.difference==true">!! </span> </td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnlba.current!=null">{{atkonfDifferencePartNumbers.tnlba.current}}</span></td>
                                </tr>
                                <tr style="border-bottom: 1px solid grey;">
                                    <td class="my_tableAtkonf_cell text-left my_font-weight_600">{{$t('3440')}}</td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnlbl.old!=null">{{atkonfDifferencePartNumbers.tnlbl.old}}</span></td>
                                    <td class="my_tableAtkonf_cell text-right my_color_c7066e"> <span v-if="atkonfDifferencePartNumbers.tnlbl.difference==true">!! </span> </td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnlbl.current!=null">{{atkonfDifferencePartNumbers.tnlbl.current}}</span></td>
                                </tr>
                                <tr style="border-bottom: 1px solid grey;">
                                    <td class="my_tableAtkonf_cell text-left my_font-weight_600">{{$t('3540')}}</td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnlogo.old!=null">{{atkonfDifferencePartNumbers.tnlogo.old}}</span></td>
                                    <td class="my_tableAtkonf_cell text-right my_color_c7066e"> <span v-if="atkonfDifferencePartNumbers.tnlogo.difference==true">!! </span> </td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnlogo.current!=null">{{atkonfDifferencePartNumbers.tnlogo.current}}</span></td>
                                </tr>
                                <tr style="border-bottom: 1px solid grey;">
                                    <td class="my_tableAtkonf_cell text-left my_font-weight_600">{{$t('3539')}}</td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnfarb.old!=null">{{atkonfDifferencePartNumbers.tnfarb.old}}</span></td>
                                    <td class="my_tableAtkonf_cell text-right my_color_c7066e"> <span v-if="atkonfDifferencePartNumbers.tnfarb.difference==true">!! </span> </td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnfarb.current!=null">{{atkonfDifferencePartNumbers.tnfarb.current}}</span></td>
                                </tr>
                                <tr style="border-bottom: 1px solid grey;">
                                    <td class="my_tableAtkonf_cell text-left my_font-weight_600">{{$t('3390')}} 1</td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnbaL1.old!=null">{{atkonfDifferencePartNumbers.tnbaL1.old}}</span></td>
                                    <td class="my_tableAtkonf_cell text-right my_color_c7066e"> <span v-if="atkonfDifferencePartNumbers.tnbaL1.difference==true">!! </span> </td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnbaL1.current!=null">{{atkonfDifferencePartNumbers.tnbaL1.current}}</span></td>
                                </tr>
                                <tr style="border-bottom: 1px solid grey;">
                                    <td class="my_tableAtkonf_cell text-left my_font-weight_600">{{$t('3390')}} 2</td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnbaL2.old!=null">{{atkonfDifferencePartNumbers.tnbaL2.old}}</span></td>
                                    <td class="my_tableAtkonf_cell text-right my_color_c7066e"> <span v-if="atkonfDifferencePartNumbers.tnbaL2.difference==true">!! </span> </td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnbaL2.current!=null">{{atkonfDifferencePartNumbers.tnbaL2.current}}</span></td>
                                </tr>
                                <tr style="border-bottom: 1px solid grey;">
                                    <td class="my_tableAtkonf_cell text-left my_font-weight_600">{{$t('3390')}} 3</td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnbaL3.old!=null">{{atkonfDifferencePartNumbers.tnbaL3.old}}</span></td>
                                    <td class="my_tableAtkonf_cell text-right my_color_c7066e"> <span v-if="atkonfDifferencePartNumbers.tnbaL3.difference==true">!! </span> </td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnbaL3.current!=null">{{atkonfDifferencePartNumbers.tnbaL3.current}}</span></td>
                                </tr>
                                <tr style="border-bottom: 1px solid grey;">
                                    <td class="my_tableAtkonf_cell text-left my_font-weight_600">{{$t('3547')}}</td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnfLei.old!=null">{{atkonfDifferencePartNumbers.tnfLei.old}}</span></td>
                                    <td class="my_tableAtkonf_cell text-right my_color_c7066e"> <span v-if="atkonfDifferencePartNumbers.tnfLei.difference==true">!! </span> </td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnfLei.current!=null">{{atkonfDifferencePartNumbers.tnfLei.current}}</span></td>
                                </tr>
                                <tr style="border-bottom: 1px solid grey;">
                                    <td class="my_tableAtkonf_cell text-left my_font-weight_600">{{$t('3544')}}</td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.massbl.old!=null">{{atkonfDifferencePartNumbers.massbl.old}}</span></td>
                                    <td class="my_tableAtkonf_cell text-right my_color_c7066e"> <span v-if="atkonfDifferencePartNumbers.massbl.difference==true">!! </span> </td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.massbl.current!=null">{{atkonfDifferencePartNumbers.massbl.current}}</span></td>
                                </tr>
                                <tr style="border-bottom: 1px solid grey;">
                                    <td class="my_tableAtkonf_cell text-left my_font-weight_600">{{$t('3396')}} {{$t('3382')}}</td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnmk.old!=null">{{atkonfDifferencePartNumbers.tnmk.old}}</span></td>
                                    <td class="my_tableAtkonf_cell text-right my_color_c7066e"> <span v-if="atkonfDifferencePartNumbers.tnmk.difference==true">!! </span> </td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.tnmk.current!=null">{{atkonfDifferencePartNumbers.tnmk.current}}</span></td>
                                </tr>
                                <tr style="border-bottom: 1px solid grey;">
                                    <td class="my_tableAtkonf_cell text-left my_font-weight_600">{{$t('3255')}}</td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.ftnfrb.old!=null">{{atkonfDifferencePartNumbers.ftnfrb.old}}</span></td>
                                    <td class="my_tableAtkonf_cell text-right my_color_c7066e"> <span v-if="atkonfDifferencePartNumbers.ftnfrb.difference==true">!! </span> </td>
                                    <td class="my_tableAtkonf_cell text-right"> <span v-if="atkonfDifferencePartNumbers.ftnfrb.current!=null">{{atkonfDifferencePartNumbers.ftnfrb.current}}</span></td>
                                </tr>
                            </table>
                            <div v-if="atkonfDifferencePartNumbers.atkonf?.length">
                                <div v-for="(line, index) in atkonfDifferencePartNumbers.atkonf"
                                     :key="index">
                                    {{ line }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="my_modal-footer" style="justify-content:flex-end">
                        <div>
                            <button @click="closeAtkonfDifferencePartNumbers(false)" class="btn my_btn_standard" style="margin-right:5px">{{$t('1023')}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="width:100vw !important">
            <modalOffer v-if="showModalOffer" @close="closeModalOffer" :zlw="zAlift_ID" :typ="typ"></modalOffer>
        </div>
    </div>
</template>


<script>
    import router from '../../../router';
    import SummaryInformationManual from '../../configuration/manualSteps/SummaryInformationManual';
    import Images from '../../configuration/Images';
    import ModalOffer from '../configurationSteps/SummaryOfferModal.vue'

    export default {
        name: 'ManualHome',
        components: {
            SummaryInformationManual,
            Images,
            ModalOffer,
        },
        data() {
            return {
                typ: 'm',
            }
        },
        computed: {
            zAlift_ID: {
                get() {
                    const { configNumberZLM, zlwNumber, suffixSelection } = this.$store.state.manualHome;

                    if (zlwNumber != null && zlwNumber !== '') {
                        const selectedSuffix = Array.isArray(suffixSelection)
                            ? suffixSelection.find(i => i.selected == true)
                            : null;
                        const suffix = selectedSuffix != null ? selectedSuffix.value : '';

                        return zlwNumber + '_' + suffix;
                    }

                    return configNumberZLM != null ? 'ZLM-' + configNumberZLM : '';
                },
            },
            sapProfile: {
                get() {
                    return this.$store.state.configurations.sap;
                },
            },
            Menge: {
                get() {
                    return this.$store.state.FI.Menge;
                }
            },
            Baug_Select: {
                get() {

                    return this.$store.state.FI.FI_ModelUI_selected == null ? this.$store.state.FI.FI_Model_selected : this.$store.state.FI.FI_ModelUI_selected;
                },
            },
            MNFI_Select: {
                get() {
                    return this.$store.state.FI.FI_MNFI_selected;
                },
            },
            Menue_Select: {
                get() {
                    return this.$store.state.FI.FI_MenueUI_selected == null ? this.$store.state.FI.FI_Menue_selected : this.$store.state.FI.FI_MenueUI_selected;
                },
            },
            Bal_Select: {
                get() {
                    return this.$store.state.FI.FI_BalUI_selected == null ? this.$store.state.FI.FI_Bal_selected : this.$store.state.FI.FI_BalUI_selected;
                },
            },
            MNBAL_Select: {
                get() {
                    return this.$store.state.FI.FI_MNBAL_selected;
                },
            },
            Par_Select: {
                get() {
                    return this.$store.state.FI.FI_ParUI_selected == null ? this.$store.state.FI.FI_Par_selected : this.$store.state.FI.FI_ParUI_selected;
                },
            },
            Conf_Select: {
                get() {
                    return this.$store.state.FI.FI_ConfUI_selected == null ? this.$store.state.FI.FI_Conf_selected : this.$store.state.FI.FI_ConfUI_selected;
                },
            },
            Code_Select: {
                get() {
                    return this.$store.state.FI.FI_CodeUI_selected == null ? this.$store.state.FI.FI_Code_selected : this.$store.state.FI.FI_CodeUI_selected;
                },
            },
            PAD_Select: {
                get() {
                    return this.$store.state.FI.FI_PADUI_selected == null ? this.$store.state.FI.FI_PAD_selected : this.$store.state.FI.FI_PADUI_selected;
                },
            },
            PADMN_Select: {
                get() {
                    return this.$store.state.FI.FI_MNPAD_selected;
                },
            },
            MON_Select: {
                get() {
                    return this.$store.state.FI.FI_MONUI_selected == null ? this.$store.state.FI.FI_MON_selected : this.$store.state.FI.FI_MONUI_selected;
                },
            },
            MONMN_Select: {
                get() {
                    return this.$store.state.FI.FI_MNMON_selected;
                },
            },
            ND_Select: {
                get() {
                    return this.$store.state.FI.FI_NDUI_selected == null ? this.$store.state.FI.FI_ND_selected : this.$store.state.FI.FI_NDUI_selected;
                },
            },
            NDMN_Select: {
                get() {
                    return this.$store.state.FI.FI_MNND_selected;
                },
            },
            FEF_Select: {
                get() {
                    return this.$store.state.FI.FI_FEFUI_selected == null ? this.$store.state.FI.FI_FEF_selected : this.$store.state.FI.FI_FEFUI_selected;
                },
            },
            FEFMN_Select: {
                get() {
                    return this.$store.state.FI.FI_MNFEF_selected;
                },
            },
            Rueckspeisung_Select: {
                get() {
                    return this.$store.state.FI.FI_Rueckspeisung_selected;
                },
            },
            BR_Select: {
                get() {
                    return this.$store.state.FI.FI_BRUI_selected == null ? this.$store.state.FI.FI_BR_selected : this.$store.state.FI.FI_BRUI_selected;
                },
            },
            BRMN_Select: {
                get() {
                    return this.$store.state.FI.FI_MNBR_selected;
                },
            },
            BRLT_Select: {
                get() {
                    return this.$store.state.FI.FI_BRLTUI_selected == null ? this.$store.state.FI.FI_BRLT_selected : this.$store.state.FI.FI_BRLTUI_selected;
                },
            },
            BRLTMN_Select: {
                get() {
                    return this.$store.state.FI.FI_MNBRLT_selected;
                },
            },
            Nachruestsatz_Select: {
                get() {
                    return this.$store.state.FI.FI_NachruestsatzUI_selected == null ? this.$store.state.FI.FI_Nachruestsatz_selected : this.$store.state.FI.FI_NachruestsatzUI_selected;
                },
            },
            NachruestsatzMN_Select: {
                get() {
                    return this.$store.state.FI.FI_MNNachruestsatz_selected;
                },
            },
            Nachruestsatz_Platte_Select: {
                get() {
                    return this.$store.state.FI.FI_NachruestsatzUI_Platte_selected == null ? this.$store.state.FI.FI_Nachruestsatz_Platte_selected : this.$store.state.FI.FI_NachruestsatzUI_Platte_selected;
                },
            },
            NachruestsatzMN_Platte_Select: {
                get() {
                    return this.$store.state.FI.FI_MNNachruestsatz_Platte_selected;
                },
            },
            DCP_Select: {
                get() {
                    return this.$store.state.FI.FI_DCPUI_selected == null ? this.$store.state.FI.FI_DCP_selected : this.$store.state.FI.FI_DCPUI_selected;
                },
            },
            DCPMN_Select: {
                get() {
                    return this.$store.state.FI.FI_MNDCP_selected;
                },
            },
            STO_Select: {
                get() {
                    return this.$store.state.FI.FI_STOUI_selected == null ? this.$store.state.FI.FI_STO_selected : this.$store.state.FI.FI_STOUI_selected;
                },
            },
            STOMN_Select: {
                get() {
                    return this.$store.state.FI.FI_MNSTO_selected;
                },
            },
            XOUT_Select: {
                get() {
                    return this.$store.state.FI.FI_XOUTUI_selected == null ? this.$store.state.FI.FI_XOUT_selected : this.$store.state.FI.FI_XOUTUI_selected;
                },
            },
            XOUTMN_Select: {
                get() {
                    return this.$store.state.FI.FI_MNXOUT_selected;
                },
            },
            XIN_Select: {
                get() {
                    return this.$store.state.FI.FI_XINUI_selected == null ? this.$store.state.FI.FI_XIN_selected : this.$store.state.FI.FI_XINUI_selected;
                },
            },
            XINMN_Select: {
                get() {
                    return this.$store.state.FI.FI_MNXIN_selected;
                },
            },
            ZAsbc_Select: {
                get() {
                    return this.$store.state.FI.FI_ZAsbcUI_selected == null ? this.$store.state.FI.FI_ZAsbc_selected : this.$store.state.FI.FI_ZAsbcUI_selected;
                },
            },
            ZAsbcMN_Select: {
                get() {
                    return this.$store.state.FI.FI_MNZAsbc_selected;
                },
            },
            ZAsbc_LS_Select: {
                get() {
                    return this.$store.state.FI.FI_ZAsbc_LSUI_selected == null ? this.$store.state.FI.FI_ZAsbc_LS_selected : this.$store.state.FI.FI_ZAsbc_LSUI_selected;
                },
            },
            ZAsbc_LSMN_Select: {
                get() {
                    return this.$store.state.FI.FI_MNZAsbc_LS_selected;
                },
            },
            ZAsbc_LSBA_Select: {
                get() {
                    return this.$store.state.FI.FI_ZAsbc_LSBAUI_selected == null ? this.$store.state.FI.FI_ZAsbc_LSBA_selected : this.$store.state.FI.FI_ZAsbc_LSBAUI_selected;
                },
            },
            ZAsbc_LSBAMN_Select: {
                get() {
                    return this.$store.state.FI.FI_MNZAsbc_LSBA_selected;
                },
            },
            ZAsbc_BAL_Select: {
                get() {
                    return this.$store.state.FI.FI_ZAsbc_BALUI_selected == null ? this.$store.state.FI.FI_ZAsbc_BAL_selected : this.$store.state.FI.FI_ZAsbc_BALUI_selected;
                },
            },
            ZAsbc_BALMN_Select: {
                get() {
                    return this.$store.state.FI.FI_MNZAsbc_BAL_selected;
                },
            },
            MengeEVAC: {
                get() {
                    return this.$store.state.EVAC.Menge;
                }
            },
            EVAC_Typ_select: {
                get() {
                    return this.$store.state.EVAC.EVAC_TypUI_select == null ? this.$store.state.EVAC.EVAC_Typ_select : this.$store.state.EVAC.EVAC_TypUI_select;
                },
            },
            EVAC_TypMN_select: {
                get() {
                    return this.$store.state.EVAC.EVAC_MNTyp_select;
                },
            },
            EVAC_Batt_select: {
                get() {
                    return this.$store.state.EVAC.EVAC_BattUI_select == null ? this.$store.state.EVAC.EVAC_Batt_select : this.$store.state.EVAC.EVAC_BattUI_select;
                },
            },
            EVAC_BattMN_select: {
                get() {
                    return this.$store.state.EVAC.EVAC_MNBatt_select;
                },
            },
            EVAC_Cable_select: {
                get() {
                    return this.$store.state.EVAC.EVAC_CableUI_select == null ? this.$store.state.EVAC.EVAC_Cable_select : this.$store.state.EVAC.EVAC_CableUI_select;
                },
            },
            EVAC_CableMN_select: {
                get() {
                    return this.$store.state.EVAC.EVAC_MNCable_select;
                },
            },
            EVAC_Control_Cable_select: {
                get() {
                    return this.$store.state.EVAC.EVAC_Control_CableUI_select == null ? this.$store.state.EVAC.EVAC_Control_Cable_select : this.$store.state.EVAC.EVAC_Control_CableUI_select;
                },
            },
            EVAC_Control_CableMN_select: {
                get() {
                    return this.$store.state.EVAC.EVAC_MNControl_Cable_select;
                },
            },
            EVAC_Bal_select: {
                get() {
                    return this.$store.state.EVAC.EVAC_BalUI_select == null ? this.$store.state.EVAC.EVAC_Bal_select : this.$store.state.EVAC.EVAC_BalUI_select;
                },
            },
            EVAC_BalMN_select: {
                get() {
                    return this.$store.state.EVAC.EVAC_MNBal_select;
                },
            },
            MengeZArec: {
                get() {
                    return this.$store.state.ZArec.Menge;
                }
            },
            ZArec_Typ_select: {
                get() {
                    return this.$store.state.ZArec.ZArec_TypUI_select == null ? this.$store.state.ZArec.ZArec_Typ_select : this.$store.state.ZArec.ZArec_TypUI_select;
                },
            },
            ZArec_TypMN_select: {
                get() {
                    return this.$store.state.ZArec.ZArec_MNTyp_select;
                },
            },
            ZArec_LS_select: {
                get() {
                    return this.$store.state.ZArec.ZArec_LSUI_select == null ? this.$store.state.ZArec.ZArec_LS_select : this.$store.state.ZArec.ZArec_LSUI_select;
                },
            },
            ZArec_LSMN_select: {
                get() {
                    return this.$store.state.ZArec.ZArec_MNLS_select;
                },
            },
            ZArec_BR_select: {
                get() {
                    return this.$store.state.ZArec.ZArec_BRUI_select == null ? this.$store.state.ZArec.ZArec_BR_select : this.$store.state.ZArec.ZArec_BRUI_select;
                },
            },
            ZArec_BRMN_select: {
                get() {
                    return this.$store.state.ZArec.ZArec_MNBR_select;
                },
            },
            ZArec_BRLT_select: {
                get() {
                    return this.$store.state.ZArec.ZArec_BRLTUI_select == null ? this.$store.state.ZArec.ZArec_BRLT_select : this.$store.state.ZArec.ZArec_BRLTUI_select;
                },
            },
            ZArec_BRLTMN_select: {
                get() {
                    return this.$store.state.ZArec.ZArec_MNBRLT_select;
                },
            },
            ZArec_ZApad_select: {
                get() {
                    return this.$store.state.ZArec.ZArec_ZApadUI_select == null ? this.$store.state.ZArec.ZArec_ZApad_select : this.$store.state.ZArec.ZArec_ZApadUI_select;
                },
            },
            ZArec_ZApadMN_select: {
                get() {
                    return this.$store.state.ZArec.ZArec_MNZApad_select;
                },
            },
            ZArec_BAL_select: {
                get() {
                    return this.$store.state.ZArec.ZArec_BALUI_select == null ? this.$store.state.ZArec.ZArec_BAL_select : this.$store.state.ZArec.ZArec_BALUI_select;
                },
            },
            ZArec_BALMN_select: {
                get() {
                    return this.$store.state.ZArec.ZArec_MNBAL_select;
                },
            },
            RLD_Typ_select: {
                get() {
                    return this.$store.state.ZArec.RLD_TypUI_select == null ? this.$store.state.ZArec.RLD_Typ_select : this.$store.state.ZArec.RLD_TypUI_select;
                },
            },
            RLD_TypMN_select: {
                get() {
                    return this.$store.state.ZArec.RLD_MNTyp_select;
                },
            },
            RLD_FEF_select: {
                get() {
                    return this.$store.state.ZArec.RLD_FEFUI_select == null ? this.$store.state.ZArec.RLD_FEF_select : this.$store.state.ZArec.RLD_FEFUI_select;
                },
            },
            RLD_FEFMN_select: {
                get() {
                    return this.$store.state.ZArec.RLD_MNFEF_select;
                },
            },

            plusManual: {
                get() {
                    return this.$store.state.configurations.plusManual;
                },
            },
            showAddOnPart: {
                get() {
                    if (this.zlwNumber != null || this.$store.state.inputsManual.showAddOnPart) {
                        return true;
                    }
                    return false;
                },
            },
            configurationOverviewsId: {
                get() {
                    return this.$store.state.configurations.configurationOverviewsId;
                },
            },
            motorCablesSelected: {
                get() {
                    if (this.$store.state.inputsManual.motorCablesManualData != null && this.$store.state.inputsManual.motorCablesManualData.hasOwnProperty('details')) {
                        return this.$store.state.inputsManual.motorCablesManualData;
                    }
                    return null;
                }
            },
            motorSuppliesSelected: {
                get() {
                    if (this.$store.state.inputsManual.motorSuppliesManualData != null && this.$store.state.inputsManual.motorSuppliesManualData.hasOwnProperty('details')) {
                        return this.$store.state.inputsManual.motorSuppliesManualData;
                    }
                    return null;
                },
            },
            motorPackagingSelected: {
                get() {
                    if (this.$store.state.inputsManual.motorPackagingManualData != null && this.$store.state.inputsManual.motorPackagingManualData.hasOwnProperty('details')) {
                        return this.$store.state.inputsManual.motorPackagingManualData;
                    }
                    return null;
                },
            },
            frameSelected: {
                get() {
                    if (this.$store.state.inputsManual.frameManualData != null && this.$store.state.inputsManual.frameManualData.hasOwnProperty('details')) {
                        return this.$store.state.inputsManual.frameManualData;
                    }
                    return null;
                },
            },
            motorManualDataSelected: {
                get() {
                    if (this.$store.state.inputsManual.motorManualData != null && this.$store.state.inputsManual.motorManualData.hasOwnProperty('details') && this.$store.state.inputsManual.motorManualData.details.hasOwnProperty('mN_MOT')) {
                        return this.$store.state.inputsManual.motorManualData;
                    }
                    return null;
                }
            },
            showMotorManualSelectionButton: {
                get() {
                    if (this.motorManualDataSelected != null) {
                        if (this.$store.state.inputsManual.motorManualData.kid != 'ZA' && this.$store.state.inputsManual.motorManualData.details.prodap != null) {
                            return '2'
                        }
                        return '1'
                    }
                    return '0'
                }
            },
            showMotorManualDetails: {
                get() {
                    return this.$store.state.inputsManual.showMotorDetails;
                }
            },
            showRopeGuardDetails: {
                get() {
                    return this.$store.state.ropeGuardManual.showRopeGuardDetails;
                }
            },
            showMotorCablesDetails: {
                get() {
                    return this.$store.state.manualHome.showMotorCablesDetails;
                }
            },
            showMotorSupplies: {
                get() {
                    if (this.plusManual == true && this.motorCablesSelected != null) {
                        return true;
                    }
                    return false;
                },
            },
            showMotorSuppliesDetails: {
                get() {
                    return this.$store.state.manualHome.showMotorSuppliesDetails;
                }
            },
            showMotorPackaging: {
                get() {
                    if (this.plusManual == true && this.motorSuppliesSelected != null) {
                        return true;
                    }
                    return false;
                },
            },
            showMotorPackagingDetails: {
                get() {
                    return this.$store.state.manualHome.showMotorPackagingDetails;
                }
            },
            showFrameDetails: {
                get() {
                    return this.$store.state.manualHome.showFrameDetails;
                }
            },
            showInverterDetails: {
                get() {
                    return this.$store.state.manualHome.showInverterDetails;
                }
            },
            showEVACDetails: {
                get() {
                    return this.$store.state.manualHome.showEVACDetails;
                }
            },
            showZArecDetails: {
                get() {
                    return this.$store.state.manualHome.showZArecDetails;
                }
            },
            showTemplateButton: {
                get() {
                    return this.$store.state.manualHome.showTemplateButton;
                }
            },
            zlwNumber: {
                get() {
                    return this.$store.state.manualHome.zlwNumber;
                },
            },
            ropeGuardDetailsSelected: {
                get() {
                    return this.$store.state.ropeGuardManual.ropeGuardDetailsSelected;
                },
            },
            showAtkonfDifferencePartNumbers: {
                get() {
                    if (this.$store.state.inputsManual.atkonfConfigurationDifferencePartNumbers != null && this.$store.state.inputsManual.atkonfConfigurationDifferencePartNumbers.hasOwnProperty('difference')) {
                        return this.$store.state.inputsManual.atkonfConfigurationDifferencePartNumbers.difference;
                    }
                    return false;
                },
            },
            atkonfDifferencePartNumbers: {
                get() {
                    if (this.$store.state.inputsManual.atkonfConfigurationDifferencePartNumbers != null && this.$store.state.inputsManual.atkonfConfigurationDifferencePartNumbers.hasOwnProperty('difference')) {
                        // console.log('atkonf: ', this.$store.state.inputsManual.atkonfConfigurationDifferencePartNumbers);
                        return this.$store.state.inputsManual.atkonfConfigurationDifferencePartNumbers;
                    }
                    return null;
                },
            },
            customerNameSelection: {
                get() {
                    return this.$store.state.manualHome.customerNameOverviewSelection;
                },
            },
            selectedCustomerName: {
                get() {
                    if (this.$store.state.manualHome.customerNameOverviewSelection != null && Array.isArray(this.$store.state.manualHome.customerNameOverviewSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.manualHome.customerNameOverviewSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.manualHome.customerNameOverviewSelection[firstIndex_whichMeetConditions];
                        }
                    }
                    return 'ZA'
                },
                set(value) {
                    this.change_Selected_atElementOf_customerName(value);
                }
            },
            customerName: {
                get() {
                    if (this.selectedCustomerName != null && this.selectedCustomerName.hasOwnProperty('text')) {
                        return this.selectedCustomerName.text.text;
                    }
                    return null;
                }
            },
            showModalOffer: {
                get() {
                    return this.$store.state.summary.showModalOffer;
                }
            },
        },
        created() {
            router.push('/');
            this.$store.dispatch('manualHome/get_customerNameSelectionOverview_storeAction');
            this.$store.dispatch('manualHome/check_toDos_at_manualHome_storeAction');
            this.$store.dispatch('summary/get_PriceInfo_available_storeAction');
        },

        methods: {
            closeAtkonfDifferencePartNumbers(value) {
                this.$store.commit('inputsManual/change_atkonfConfigurationDifferencePartNumbers_storeMutation', null);
            },
            ZAtop() {
                this.ChangeMotorDetails(false);
                this.$store.dispatch('configurations/change_elevatorMotor_Manual_storeAction', true);
                router.push('../manualStep/inputsManual');
            },
            ZAtop_PSG() {
                this.ChangeMotorDetails(false);
                this.$store.dispatch('configurations/change_elevatorMotor_Manual_storeAction', true);
                router.push('../manualStep/psgModal');
            },
            ZAtop_Magic() {
                this.ChangeMotorDetails(false);
                this.$store.dispatch('configurations/change_elevatorMotor_Manual_storeAction', true);
                router.push('../manualStep/psgModal');
            },
            ZAframe() {
                router.push('../manualStep/frameManual');
            },

            ZAdyn() {
                this.$store.dispatch('configurations/MANU', true)
                this.$store.dispatch('inputs/change_inputs_toDefault_storeAction');
                this.$store.dispatch('driveTechnologies/change_driveTechnologies_toDefault_storeAction');
                this.$store.dispatch('controlTechnologies/change_controlTechnologies_toDefault_storeAction');
                this.$store.dispatch('summary/change_summary_toDefault_storeAction');
                this.$store.dispatch('configurations/change_configurations_toDefault_storeAction');
                //this.$store.dispatch('controlTechnologies/get_FI_Type_storeAction')

                this.$store.dispatch('FI/get_FI_Type_storeAction');

                this.$store.dispatch('FI/get_FI_Load');

                if (this.$store.state.FI.Menge == null) {

                    this.$store.dispatch('FI/change_FI_Menge_storeAction', 1);
                    if (this.$store.state.manualHome.Quantity_Motor != 1 && this.$store.state.manualHome.Quantity_Motor != null) {
                        this.$store.dispatch('FI/change_FI_Menge_storeAction', this.$store.state.manualHome.Quantity_Motor);
                    }
                }
                

                router.push('../manualStep/FI');
            },

            EVAC() {
                this.$store.dispatch('EVAC/get_EVAC_Typ_storeAction');
                this.$store.dispatch('EVAC/get_EVAC_Load');

                /*this.$store.state.manualHome.showTemplateButton;*/

                if (this.$store.state.EVAC.Menge == null) {

                    this.$store.dispatch('EVAC/change_EVAC_Menge_storeAction', 1);
                    if (this.$store.state.manualHome.Quantity_Motor != 1 && this.$store.state.manualHome.Quantity_Motor != null) {
                        this.$store.dispatch('EVAC/change_EVAC_Menge_storeAction', this.$store.state.manualHome.Quantity_Motor);
                    }
                }

                router.push('../manualStep/EVAC');
            },

            ZArec() {
                this.$store.dispatch('ZArec/get_ZArec_Typ_storeAction');
                this.$store.dispatch('ZArec/get_RLD_Typ_storeAction');

                this.$store.dispatch('ZArec/get_ZArec_Load');

                if (this.$store.state.ZArec.Menge == null) {

                    this.$store.dispatch('ZArec/change_ZArec_Menge_storeAction', 1);
                    if (this.$store.state.manualHome.Quantity_Motor != 1 && this.$store.state.manualHome.Quantity_Motor != null) {
                        this.$store.dispatch('ZArec/change_ZArec_Menge_storeAction', this.$store.state.manualHome.Quantity_Motor);
                    }
                }

                router.push('../manualStep/ZArec');
            },

            deleteZAtop() {
                this.$store.dispatch('manualHome/delete_calculationZAtop_storeAction');
            },
            deleteFrame() {
                this.$store.dispatch('manualHome/delete_calculationFrame_storeAction');
            },
            deleteZAdyn() {
                this.$store.dispatch('manualHome/delete_calculationZAdyn_storeAction');
            },
            deleteEVAC() {
                this.$store.dispatch('manualHome/delete_calculationEVAC_storeAction');
            },
            deleteZArec() {
                this.$store.dispatch('manualHome/delete_calculationZArec_storeAction');
            },
            RLD() {
                router.push('../manualStep/RLD');
            },
            MotorCables() {
                router.push('../manualStep/cables');
            },
            MotorSupplies() {
                router.push('../manualStep/suppliesMotorManual')
            },
            MotorPackaging() {
                router.push('../manualStep/packagingMotorManual')
            },
            informationAtkonf() {
                this.$store.dispatch('inputsManual/get_informationAtkonf_storeAction')
            },
            ChangeMotorDetails(value) {
                this.$store.commit('inputsManual/change_showMotorDetails_storeMutation', value)
            },
            ChangeRopeGuardDetails(value) {
                this.$store.commit('ropeGuardManual/change_showRopeGuardDetails_storeMutation', value)
            },
            ChangeAddOnPart() {
                router.push('../manualStep/addOnPartModal');
            },
            ChangeMotorCablesDetails(value) {
                this.$store.commit('manualHome/change_showMotorCablesDetails_storeMutation', value)
            },
            ChangeMotorSuppliesDetails(value) {
                this.$store.commit('manualHome/change_showMotorSuppliesDetails_storeMutation', value)
            },
            ChangeMotorPackagingDetails(value) {
                this.$store.commit('manualHome/change_showMotorPackagingDetails_storeMutation', value)
            },
            ChangeFrameDetails(value) {
                this.$store.commit('manualHome/change_showMotorFrameDetails_storeMutation', value)
            },
            ChangeInverterDetails(value) {
                this.$store.commit('manualHome/change_showInverterDetails_storeMutation', value)
            },
            ChangeEVACDetails(value) {
                this.$store.commit('manualHome/change_showEVACDetails_storeMutation', value)
            },
            ChangeZArecDetails(value) {
                this.$store.commit('manualHome/change_showZArecDetails_storeMutation', value)
            },
            change_partNumberMklk(value) {
                this.$store.dispatch('inputsManual/change_partNumberMklk_storeAction', value);
            },
            change_Selected_atElementOf_customerName(value) {
                this.$store.dispatch('manualHome/change_customerNameOverview_storeAction', value);
            },
            closeModalOffer() {
                this.$store.commit('summary/change_showModalOffer_storeMutation', false)
            },
        },
    }
</script>


<style>
    .my_tableAtkonf_cell {
        padding: 8px;
    }

    .my_typeOfSuspensionMeans {
        list-style: none;
        background-color: #ffffff;
        padding: 0;
        margin: 0;
    }

        .my_typeOfSuspensionMeans li {
            border: 2px solid #00338e;
            color: #000000;
            display: inline-block;
            padding: 0.3rem;
            text-align: center;
            width: 50%;
        }

        .my_typeOfSuspensionMeans .active {
            background-color: #00338e;
            color: #ffffff;
        }

    .classC {
        margin-top: 78px;
    }

    .input_margin-bottom {
        margin-bottom: 20px;
    }
</style>
